import { Partner } from '../model/partner.model';

export const partnerSalons: Partner[] = [
    {
        id: '1',
        order: 68,
        name: 'Jubiler Głódkowski',
        originalAddress: 'Ul. Mickiewicza 4, 40-092 Katowice',
        address: {
            street: 'ul. Mickiewicza 4',
            city: 'Katowice',
            postalCode: '40-092',
        },
        originalPhone: '505353853 322538976 jubiler@jubiler-glodkowski.pl',
        phones: ['+48 505 353 853', '+48 322 538 976'],
        emails: ['jubiler@jubiler-glodkowski.pl'],
        www: ['https://jubiler-glodkowski.pl'],
        voivodeship: 'slaskie',
        logo: 'glodkowski-logo.png',
        path: 'jubiler-glodkowski',
    },
    {
        id: '10',
        order: 88,
        name: 'Jubiler Dubiel',
        originalAddress: 'ul.Gazownicza 5 , 43-300 Bielsko-Biała, Centrum Handlowe WAGA',
        address: {
            street: 'ul. Gazownicza 5',
            city: 'Bielsko-Biała',
            postalCode: '43-300',
            place: 'Centrum Handlowe WAGA',
        },
        originalPhone: '+48 504-088-888 biuro@jubilerdubiel.pl',
        phones: ['+48 504 088 888'],
        emails: ['biuro@jubilerdubiel.pl'],
        www: ['https://www.jubilerdubiel.pl'],
        voivodeship: 'slaskie',
        logo: 'dubiel.png',
        path: 'jubiler-dubiel',
    },
    {
        id: '100',
        order: 36,
        name: 'Pracownia Złotnicza Benedykt Wacnik',
        originalAddress: 'ul.Biała 1, Bochnia 32-700',
        address: {
            street: 'ul. Biała 1',
            city: 'Bochnia',
            postalCode: '32-700',
        },
        originalPhone: '+48 146118009, 605440065',
        phones: ['+48 146 118 009', '+48 605 440 065'],
        emails: [],
        www: [],
        voivodeship: 'malopolskie',
        logo: 'placeholder.png',
        path: 'pracownia-zlotnicza-benedykt-wacnik',
    },
    {
        id: '101',
        order: 79,
        name: 'JUBILER POŚPIECH',
        originalAddress: '44-200 Rybnik, Plac Wolności 15',
        address: {
            street: 'Plac Wolności 15',
            city: 'Rybnik',
            postalCode: '44-200',
        },
        originalPhone: '797 762 088 jubilerpospiech@gmail.com',
        phones: ['+48 797 762 088 '],
        emails: ['jubilerpospiech@gmail.com'],
        www: ['https://www.jubilerpospiech.pl'],
        voivodeship: 'slaskie',
        logo: 'pospiech.png',
        path: 'jubiler-pospiech-rybnik',
    },
    {
        id: '102',
        order: 80,
        name: 'JUBILER POŚPIECH',
        originalAddress: '47-400 Racibórz, ul. Mickiewicza 13',
        address: {
            street: 'ul. Mickiewicza 13',
            city: 'Racibórz',
            postalCode: '47-400',
        },
        originalPhone: '48533661319 jubilerpospiech@gmail.com',
        phones: ['+48 533 661 319'],
        emails: ['jubilerpospiech@gmail.com'],
        www: ['https://www.jubilerpospiech.pl'],
        voivodeship: 'slaskie',
        logo: 'pospiech.png',
        path: 'jubiler-pospiech-raciborz',
    },
    {
        id: '103',
        order: 81,
        name: 'JUBILER POŚPIECH',
        originalAddress: '47-400 Racibórz, ul. Opawska 18',
        address: {
            street: 'ul. Opawska 18',
            city: 'Racibórz',
            postalCode: '47-400',
        },
        originalPhone: '48796028398 jubilerpospiech@gmail.com',
        phones: ['+48 796 028 398'],
        emails: ['jubilerpospiech@gmail.com'],
        www: ['https://www.jubilerpospiech.pl'],
        voivodeship: 'slaskie',
        logo: 'pospiech.png',
        path: 'jubiler-pospiech-raciborz-opawska-18',
    },
    {
        id: '104',
        order: 40,
        name: 'DIAMENT Jubiler',
        originalAddress: 'ul. Sobieskiego 8a 34-480 Jabłonka',
        address: {
            street: 'ul. Sobieskiego 8a',
            city: 'Jabłonka',
            postalCode: '34-480',
        },
        originalPhone: '791057276 mail: sklep.diamentjubiler@gmail.com',
        phones: ['+48 791 057 276'],
        emails: ['sklep.diamentjubiler@gmail.com'],
        www: ['https://www.diamentjubiler.pl'],
        voivodeship: 'malopolskie',
        logo: 'diament-jubiler.png',
        path: 'diament-jubiler',
    },
    {
        id: '105',
        order: 90,
        name: 'DIAMANTI s.c.',
        originalAddress: 'ul. Metalowców 13 41-500 Chorzów',
        address: {
            street: 'ul. Metalowców 13',
            city: 'Chorzów',
            postalCode: '41-500',
        },
        originalPhone: '+48 691 421 144 kontakt@diamanti.pl',
        phones: ['+48 691 421 144'],
        emails: ['kontakt@diamanti.pl'],
        www: ['https://www.diamanti.pl'],
        voivodeship: 'slaskie',
        logo: 'diamanti.png',
        path: 'diamanti-sc',
    },
    {
        id: '106',
        order: 108,
        name: 'Jaspis Rafał Wojciechowski',
        originalAddress: 'Ul. Narutowicza 2 64-100 Leszno',
        address: {
            street: 'ul. Narutowicza 2',
            city: 'Leszno',
            postalCode: '64-100',
        },
        originalPhone: '792001576 email : jaspis14@vp.pl',
        phones: ['+48 792 001 576'],
        emails: ['jaspis14@vp.pl'],
        www: [],
        voivodeship: 'wielkopolskie',
        logo: 'jaspis.png',
        path: 'jaspis-rafal-wojciechowski',
    },
    {
        id: '107',
        order: 106,
        name: 'NIX Pracownia Złotnicza',
        originalAddress: 'ul. Różana 14 63-400 Ostrów Wielkopolski',
        address: {
            street: 'ul. Różana 14',
            city: 'Ostrów Wielkopolski',
            postalCode: '63-400',
        },
        originalPhone: '(62)736-55-06',
        phones: ['+48 62 736 55 06'],
        emails: [],
        www: ['https://www.nix.com.pl'],
        voivodeship: 'wielkopolskie',
        logo: 'nix.png',
        path: 'nix-pracownia-zlotnicza',
    },
    {
        id: '109',
        order: 5,
        name: 'Jubiler s.c. Mariusz Baszczyński & Marek Krukowski',
        originalAddress: 'Ul. Ruska 36 50-079 Wrocław',
        address: {
            street: 'ul. Ruska 36',
            city: 'Wrocław',
            postalCode: '50-079',
        },
        originalPhone: '71-3445623 Mail: kontakt@jubilerwroclaw.pl',
        phones: ['+48 71 344 56 23'],
        emails: ['kontakt@jubilerwroclaw.pl'],
        www: ['https://www.jubilerwroclaw.pl'],
        voivodeship: 'dolnoslaskie',
        logo: 'baszczynski-krukowski.png',
        path: 'jubiler-sc-mariusz-baszczynski-marek-krukowski',
    },
    {
        id: '11',
        order: 88,
        name: 'OnyxHard Jubiler',
        originalAddress: 'Ul. Niepodległości 14 41-106 Siemianowice Śląskie',
        address: {
            street: 'ul. Niepodległości 14',
            city: 'Siemianowice Śląskie',
            postalCode: '41-106',
        },
        originalPhone: '503 190 850 792 626 166 jubiler@onyxhard.pl',
        phones: ['+48 503 190 850', '+48 792 626 166'],
        emails: ['jubiler@onyxhard.pl'],
        www: ['https://www.onyxhard.pl'],
        voivodeship: 'slaskie',
        logo: 'onyxhard-logo.png',
        path: 'onyxhard-jubiler',
    },
    {
        id: '110',
        order: 104,
        name: 'Pracownia Złotnicza Piotr Domagała',
        originalAddress: 'ul. Wiosny Ludów 11 62-500 Konin',
        address: {
            street: 'ul. Wiosny Ludów 11',
            city: 'Konin',
            postalCode: '62-500',
        },
        originalPhone: '632428096 kontakt@jubiler-domagala.pl',
        phones: ['+48 632 428 096'],
        emails: ['kontakt@jubiler-domagala.pl'],
        www: ['https://www.jubiler-domagala.pl'],
        voivodeship: 'wielkopolskie',
        logo: 'domagala.png',
        path: 'pracownia-zlotnicza-piotr-domagala',
    },
    {
        id: '12',
        order: 89,
        name: 'Jubiler M.Karpisz',
        originalAddress: 'Rynek 1/18, 47-400 Racibórz',
        address: {
            street: 'Rynek 1/18',
            city: 'Racibórz',
            postalCode: '47-400',
        },
        originalPhone: '324153343 jubilerkarpisz@gmail.com',
        phones: ['+48 324 153 343'],
        emails: ['jubilerkarpisz@gmail.com'],
        www: [],
        socials: {
            facebook: 'https://www.facebook.com/JubilerRaciborzKarpisz',
        },
        voivodeship: 'slaskie',
        logo: 'm-karpisz.png',
        path: 'jubiler-mkarpisz',
    },
    {
        id: '13',
        order: 75,
        name: 'Firma Jubilerska Kozłowski',
        originalAddress: 'ul. Barlickiego 2 43-300 Bielsko-Biała',
        address: {
            street: 'ul. Barlickiego 2',
            city: 'Bielsko-Biała',
            postalCode: '43-300',
        },
        originalPhone: '665 396 217 jubilerbielsko@gmail.com',
        phones: ['+48 665 396 217'],
        emails: ['jubilerbielsko@gmail.com'],
        www: ['https://www.jubilerbielsko.pl'],
        voivodeship: 'slaskie',
        logo: 'kozlowski.png',
        path: 'firma-jubilerska-kozlowski',
    },
    {
        id: '14',
        order: 73,
        name: 'Firma Jubilerka Aktynolit Barbara Błąd',
        originalAddress: 'ul.Ks. Herberta Hlubka 3 44-100 Gliwice',
        address: {
            street: 'ul. Ks. Herberta Hlubka 3',
            city: 'Gliwice',
            postalCode: '44-100',
        },
        originalPhone: '322319355 aktynolit@gmail.com',
        phones: ['+48 322 319 355'],
        emails: ['aktynolit@gmail.com'],
        www: [],
        socials: {
            facebook: 'https://www.facebook.com/aktynolit',
        },
        voivodeship: 'slaskie',
        logo: 'aktynolit.png',
        path: 'firma-jubilerka-aktynolit-barbara-blad',
    },
    {
        id: '15',
        order: 74,
        name: 'Firma Jubilerska Adamas',
        originalAddress: 'ul. Pszczyńska 44A, 44-100 Gliwice',
        address: {
            street: 'ul. Pszczyńska 44A',
            city: 'Gliwice',
            postalCode: '44-100',
        },
        originalPhone: '721 122 122 32 3000 555 adamas@adamas.pl',
        phones: ['+48 721 122 122', '+48 323 000 555'],
        emails: ['adamas@adamas.pl'],
        www: ['https://www.adamas.pl'],
        voivodeship: 'slaskie',
        logo: 'adamas.png',
        path: 'firma-jubilerska-adamas',
    },
    {
        id: '16',
        order: 13,
        name: 'Luva',
        originalAddress: 'ul. Długa 27, 31-147 Kraków',
        address: {
            street: 'ul. Długa 27',
            city: 'Kraków',
            postalCode: '31-147',
        },
        originalPhone: '799 964 444 sklep@luva.pl',
        phones: ['+48 799 964 444'],
        emails: ['sklep@luva.pl'],
        www: ['https://luva.pl'],
        voivodeship: 'malopolskie',
        logo: 'luva.png',
        path: 'luva-krakow',
    },
    {
        id: '17',
        order: 61,
        name: 'Luva',
        originalAddress: 'ul. Mikołaja Kopernika 4 40-064 Katowice',
        address: {
            street: 'ul. Mikołaja Kopernika 4',
            city: 'Katowice',
            postalCode: '40-064',
        },
        originalPhone: '799 964 442 sklep@luva.pl',
        phones: ['+48 799 964 442'],
        emails: ['sklep@luva.pl'],
        www: ['https://luva.pl'],
        voivodeship: 'slaskie',
        logo: 'luva.png',
        path: 'luva-katowice',
    },
    {
        id: '18',
        order: 45,
        name: 'Luva',
        originalAddress: 'ul. Koszykowa 54 00-675 Warszawa',
        address: {
            street: 'ul. Koszykowa 54',
            city: 'Warszawa',
            postalCode: '00-675',
        },
        originalPhone: '799 964 440 sklep@luva.pl',
        phones: ['+48 799 964 440'],
        emails: ['sklep@luva.pl'],
        www: ['https://luva.pl'],
        voivodeship: 'mazowieckie',
        logo: 'luva.png',
        path: 'luva-warszawa',
    },
    {
        id: '19',
        order: 9,
        name: 'Salonik Jubilerski Unico',
        originalAddress: 'ul. 3 Maja 4 59-100 Polkowice',
        address: {
            street: 'ul. 3 Maja 4',
            city: 'Polkowice',
            postalCode: '59-100',
        },
        originalPhone: '693 588 995 info@bizuteria-unico.pl',
        phones: ['+48 693 588 995'],
        emails: ['info@bizuteria-unico.pl'],
        www: ['https://www.bizuteria-unico.pl'],
        voivodeship: 'dolnoslaskie',
        logo: 'unico.png',
        path: 'salonik-jubilerski-unico',
    },
    {
        id: '2',
        order: 53,
        name: 'AMAZYT JUBILER',
        originalAddress: 'Radom 26-600, ul. Traugutta 27/4',
        address: {
            street: 'ul. Traugutta 27/4',
            city: 'Radom',
            postalCode: '26-600',
        },
        originalPhone: '48 360-04-10 amazyt@amazyt.pl',
        phones: ['+48 48 360 04 10'],
        emails: ['amazyt@amazyt.pl'],
        www: ['https://www.amazyt.pl'],
        voivodeship: 'mazowieckie',
        logo: 'amazyt.png',
        path: 'amazyt-jubiler',
    },
    {
        id: '20',
        order: 107,
        name: 'DIAMENT OPALENICA',
        originalAddress: 'Jana Pawła II 2 64-330 Opalenica',
        address: {
            street: 'Jana Pawła II 2',
            city: 'Opalenica',
            postalCode: '64-330',
        },
        originalPhone: '696 988 029 info@diamentobraczki.pl',
        phones: ['+48 696 988 029'],
        emails: ['info@diamentobraczki.pl'],
        www: ['https://www.diamentobraczki.pl'],
        voivodeship: 'wielkopolskie',
        logo: 'diament-opalenica.png',
        path: 'diament-opalenica',
    },
    {
        id: '21',
        order: 7,
        name: 'Salon Zeccoro',
        originalAddress: 'ul. Świdnicka 6a 50-067 Wrocław',
        address: {
            street: 'ul. Świdnicka 6a',
            city: 'Wrocław',
            postalCode: '50-067',
        },
        originalPhone: '48797009677 salon.wroclaw@zeccoro.pl',
        phones: ['+48 797 009 677'],
        emails: ['salon.wroclaw@zeccoro.pl'],
        www: ['https://www.zeccoro.pl'],
        voivodeship: 'dolnoslaskie',
        logo: 'zeccoro.png',
        path: 'salon-zeccoro',
    },
    {
        id: '22',
        order: 8,
        name: 'Salon Zeccoro',
        originalAddress: 'Sucha 1 50-086 Wrocław',
        address: {
            place: 'Wroclavia',
            street: 'Sucha 1',
            city: 'Wrocław',
            postalCode: '50-086',
        },
        originalPhone: '48797487559 wroclavia@zeccoro.pl',
        phones: ['+48 797 487 559'],
        emails: ['wroclavia@zeccoro.pl'],
        www: ['https://www.zeccoro.pl'],
        voivodeship: 'dolnoslaskie',
        logo: 'zeccoro.png',
        path: 'salon-zeccoro-wroclavia',
    },
    {
        id: '23',
        order: 38,
        name: 'Sklep Jubilerski Lucyna Surówka',
        originalAddress: 'Ul. Reja 8 32-400 Myślenice',
        address: {
            street: 'ul. Reja 8',
            city: 'Myślenice',
            postalCode: '32-400',
        },
        originalPhone: '603-033-990 pawelzglejszewski@op.pl',
        phones: ['+48 603 033 990'],
        emails: ['pawelzglejszewski@op.pl'],
        www: ['https://www.jubilermyslenice.pl'],
        voivodeship: 'malopolskie',
        logo: 'sklep-jubilerski-lucyna-surowka.png',
        path: 'sklep-jubilerski-lucyna-surowka',
        bgColor: '#031d43',
    },
    {
        id: '24',
        order: 26,
        name: 'Jubiler Sezam',
        originalAddress: 'ul. Rynek 10, Stary Sącz 33-340',
        address: {
            street: 'ul. Rynek 10',
            city: 'Stary Sącz',
            postalCode: '33-340',
        },
        originalPhone: '515468941 starysacz@jubilersezam.pl',
        phones: ['+48 515 468 941'],
        emails: ['starysacz@jubilersezam.pl'],
        www: ['https://www.jubilersezam.pl'],
        voivodeship: 'malopolskie',
        logo: 'sezam.png',
        path: 'jubiler-sezam-stary-sacz',
    },
    {
        id: '25',
        order: 27,
        name: 'Jubiler Sezam',
        originalAddress: 'ul. Lwowska 80, Nowy Sącz 33-300',
        address: {
            street: 'ul. Lwowska 80',
            city: 'Nowy Sącz',
            postalCode: '33-300',
        },
        originalPhone: '505041792 trzykorony@jubilersezam.pl',
        phones: ['+48 505 041 792'],
        emails: ['trzykorony@jubilersezam.pl'],
        www: ['https://www.jubilersezam.pl'],
        voivodeship: 'malopolskie',
        logo: 'sezam.png',
        path: 'jubiler-sezam-nowy-sacz',
    },
    {
        id: '26',
        order: 28,
        name: 'Jubiler Sezam',
        originalAddress: 'ul. Słoneczna 2E, Myślenice 32-400',
        address: {
            street: 'ul. Słoneczna 2E',
            city: 'Myślenice',
            postalCode: '32-400',
        },
        originalPhone: '515468910 gal.myslenicka@jubilersezam.pl',
        phones: ['+48 515 468 910'],
        emails: ['gal.myslenicka@jubilersezam.pl'],
        www: ['https://www.jubilersezam.pl'],
        voivodeship: 'malopolskie',
        logo: 'sezam.png',
        path: 'jubiler-sezam-myslenice',
    },
    {
        id: '27',
        order: 29,
        name: 'Jubiler Sezam',
        originalAddress: 'ul. Reja 1a, Myślenice 32-400',
        address: {
            street: 'ul. Reja 1a',
            city: 'Myślenice',
            postalCode: '32-400',
        },
        originalPhone: '510089458 myslenice@jubilersezam.pl',
        phones: ['+48 510 089 458'],
        emails: ['myslenice@jubilersezam.pl'],
        www: ['https://www.jubilersezam.pl'],
        voivodeship: 'malopolskie',
        logo: 'sezam.png',
        path: 'jubiler-sezam-myslenice-reja-1a',
    },
    {
        id: '28',
        order: 30,
        name: 'Jubiler Sezam',
        originalAddress: 'ul. Krakowska 149, Tarnów 33-100',
        address: {
            street: 'ul. Krakowska 149',
            city: 'Tarnów',
            postalCode: '33-100',
        },
        originalPhone: '505106562 tarnovia@jubilersezam.pl',
        phones: ['+48 505 106 562'],
        emails: ['tarnovia@jubilersezam.pl'],
        www: ['https://www.jubilersezam.pl'],
        voivodeship: 'malopolskie',
        logo: 'sezam.png',
        path: 'jubiler-sezam-tarnow',
    },
    {
        id: '29',
        order: 31,
        name: 'Jubiler Sezam',
        originalAddress: 'ul. Szkotnik 1, Tarnów 33-100',
        address: {
            street: 'ul. Szkotnik 1',
            city: 'Tarnów',
            postalCode: '33-100',
        },
        originalPhone: '510089462 max@jubilersezam.pl',
        phones: ['+48 510 089 462'],
        emails: ['max@jubilersezam.pl'],
        www: ['https://www.jubilersezam.pl'],
        voivodeship: 'malopolskie',
        logo: 'sezam.png',
        path: 'jubiler-sezam-tarnow-szkotnik-1',
    },
    {
        id: '3',
        order: 19,
        name: 'Me Flore Jewellery',
        originalAddress: 'ul. Lubicz 40, 31-512 Kraków',
        address: {
            street: 'ul. Lubicz 40',
            city: 'Kraków',
            postalCode: '31-512',
        },
        originalPhone: '+48 518 067 009 kontakt@meflore.pl',
        phones: ['+48 518 067 009'],
        emails: ['kontakt@meflore.pl'],
        www: ['https://www.meflore.pl'],
        voivodeship: 'malopolskie',
        logo: 'me-flore.png',
        path: 'me-flore-jewellery',
    },
    {
        id: '30',
        order: 32,
        name: 'Jubiler Sezam',
        originalAddress: 'ul. Składowa 2, Nowy Targ 34-400',
        address: {
            street: 'ul. Składowa 2',
            city: 'Nowy Targ',
            postalCode: '34-400',
        },
        originalPhone: '510089459 nowytarg@jubilersezam.pl',
        phones: ['+48 510 089 459'],
        emails: ['nowytarg@jubilersezam.pl'],
        www: ['https://www.jubilersezam.pl'],
        voivodeship: 'malopolskie',
        logo: 'sezam.png',
        path: 'jubiler-sezam-nowy-targ',
    },
    {
        id: '31',
        order: 33,
        name: 'Jubiler Sezam',
        originalAddress: 'ul. Ludźmierska 26A, Nowy Targ 34-400',
        address: {
            street: 'ul. Ludźmierska 26A',
            city: 'Nowy Targ',
            postalCode: '34-400',
        },
        originalPhone: '503194234 stopiakpark@jubilersezam.pl',
        phones: ['+48 503 194 234'],
        emails: ['stopiakpark@jubilersezam.pl'],
        www: ['https://www.jubilersezam.pl'],
        voivodeship: 'malopolskie',
        logo: 'sezam.png',
        path: 'jubiler-sezam-nowy-targ-ludzmierska-26a',
    },
    {
        id: '32',
        order: 34,
        name: 'Jubiler Sezam',
        originalAddress: 'ul. Józefa Marka 12, Limanowa 34-600',
        address: {
            street: 'ul. Józefa Marka 12',
            city: 'Limanowa',
            postalCode: '34-600',
        },
        originalPhone: '508300318 limanowa@jubilersezam.pl',
        phones: ['+48 508 300 318'],
        emails: ['limanowa@jubilersezam.pl'],
        www: ['https://www.jubilersezam.pl'],
        voivodeship: 'malopolskie',
        logo: 'sezam.png',
        path: 'jubiler-sezam-limanowa',
    },
    {
        id: '33',
        order: 35,
        name: 'Jubiler Sezam',
        originalAddress: 'ul. Zygmunta Augusta 12d, Limanowa 34-600',
        address: {
            street: 'ul. Zygmunta Augusta 12d',
            city: 'Limanowa',
            postalCode: '34-600',
        },
        originalPhone: '510089454 s-mall@jubilersezam.pl',
        phones: ['+48 510 089 454'],
        emails: ['s-mall@jubilersezam.pl'],
        www: ['https://www.jubilersezam.pl'],
        voivodeship: 'malopolskie',
        logo: 'sezam.png',
        path: 'jubiler-sezam-limanowa-zygmunta-augusta-12d',
    },
    {
        id: '34',
        order: 25,
        name: 'Jubiler Sezam',
        originalAddress: 'ul. Galicyjska 10, Kraków 31-586',
        address: {
            street: 'ul. Galicyjska 10',
            city: 'Kraków',
            postalCode: '31-586',
        },
        originalPhone: '505303391 krakow@jubilersezam.pl',
        phones: ['+48 505 303 391'],
        emails: ['krakow@jubilersezam.pl'],
        www: ['https://www.jubilersezam.pl'],
        voivodeship: 'malopolskie',
        logo: 'sezam.png',
        path: 'jubiler-sezam-krakow',
    },
    {
        id: '35',
        order: 0,
        name: 'Jubiler Schubert',
        originalAddress: 'CH Korona, Bolesława Krzywoustego 126, 51-421 Wrocław',
        address: {
            street: 'Bolesława Krzywoustego 126',
            city: 'Wrocław',
            postalCode: '51-421',
            place: 'CH Korona',
        },
        originalPhone: '503 985 152 e-sklep@jubilerschubert.pl',
        phones: ['+48 503 985 152'],
        emails: ['e-sklep@jubilerschubert.pl'],
        www: ['https://jubilerschubert.pl'],
        voivodeship: 'dolnoslaskie',
        logo: 'schubert.png',
        path: 'jubiler-schubert-wroclaw',
    },
    {
        id: '36',
        order: 1,
        name: 'Jubiler Schubert',
        originalAddress: 'Czekoladowa 7, 55-040 Bielany Wrocławskie',
        address: {
            street: 'Czekoladowa 7',
            city: 'Bielany Wrocławskie',
            postalCode: '55-040',
        },
        originalPhone: '503 986 618 e-sklep@jubilerschubert.pl',
        phones: ['+48 503 986 618'],
        emails: ['e-sklep@jubilerschubert.pl'],
        www: ['https://jubilerschubert.pl'],
        voivodeship: 'dolnoslaskie',
        logo: 'schubert.png',
        path: 'jubiler-schubert-bielany-wroclawskie',
    },
    {
        id: '37',
        order: 59,
        name: 'Jubiler Schubert',
        originalAddress: 'Gen. Kazimierza Pułaskiego 60, 40-959 Katowice',
        address: {
            street: 'Gen. Kazimierza Pułaskiego 60',
            city: 'Katowice',
            postalCode: '40-959',
        },
        originalPhone: '503 985 621 e-sklep@jubilerschubert.pl',
        phones: ['+48 503 985 621'],
        emails: ['e-sklep@jubilerschubert.pl'],
        www: ['https://jubilerschubert.pl'],
        voivodeship: 'slaskie',
        logo: 'schubert.png',
        path: 'jubiler-schubert-katowice',
    },
    {
        id: '38',
        order: 60,
        name: 'Jubiler Schubert',
        originalAddress: 'C.H. Platan, plac Teatralny 10, 41-800 Zabrze',
        address: {
            street: 'plac Teatralny 10',
            city: 'Zabrze',
            postalCode: '41-800',
            place: 'C.H. Platan',
        },
        originalPhone: '503 985 683 e-sklep@jubilerschubert.pl',
        phones: ['+48 503 985 683'],
        emails: ['e-sklep@jubilerschubert.pl'],
        www: ['https://jubilerschubert.pl'],
        voivodeship: 'slaskie',
        logo: 'schubert.png',
        path: 'jubiler-schubert-zabrze',
    },
    {
        id: '39',
        order: 41,
        name: 'Jubiler Schubert',
        originalAddress: 'Mszczonowska 3, 05-090 Janki',
        address: {
            street: 'Mszczonowska 3',
            city: 'Janki',
            postalCode: '05-090',
        },
        originalPhone: '503 986 750 e-sklep@jubilerschubert.pl',
        phones: ['+48 503 986 750'],
        emails: ['e-sklep@jubilerschubert.pl'],
        www: ['https://jubilerschubert.pl'],
        voivodeship: 'mazowieckie',
        logo: 'schubert.png',
        path: 'jubiler-schubert-janki',
    },
    {
        id: '4',
        order: 92,
        name: 'Pracownia Złotnicza Renata Skutnik',
        originalAddress: 'ul.Śląska5 Piekary Śląskie 41-943',
        address: {
            street: 'ul. Śląska 5',
            city: 'Piekary Śląskie',
            postalCode: '41-943',
        },
        originalPhone: '699902481 marcinskutnik@gmail.com',
        phones: ['+48 699 902 481'],
        emails: ['marcinskutnik@gmail.com'],
        www: ['https://www.skutnik24.pl'],
        voivodeship: 'slaskie',
        logo: 'skutnik24.png',
        path: 'pracownia-zlotnicza-renata-skutnik',
    },
    {
        id: '40',
        order: 42,
        name: 'Jubiler Schubert',
        originalAddress: 'C.H. King Cross, Jubilerska 1/3, 04-190 Warszawa',
        address: {
            street: 'Jubilerska 1/3',
            city: 'Warszawa',
            postalCode: '04-190',
            place: 'C.H. King Cross',
        },
        originalPhone: '503985902 e-sklep@jubilerschubert.pl',
        phones: ['+48 503 985 902'],
        emails: ['e-sklep@jubilerschubert.pl'],
        www: ['https://jubilerschubert.pl'],
        voivodeship: 'mazowieckie',
        logo: 'schubert.png',
        path: 'jubiler-schubert-warszawa',
    },
    {
        id: '41',
        order: 43,
        name: 'Jubiler Schubert',
        originalAddress: 'Głębocka 15, 03-287 Warszawa',
        address: {
            street: 'Głębocka 15',
            city: 'Warszawa',
            postalCode: '03-287',
        },
        originalPhone: '503986242 e-sklep@jubilerschubert.pl',
        phones: ['+48 503 986 242'],
        emails: ['e-sklep@jubilerschubert.pl'],
        www: ['https://jubilerschubert.pl'],
        voivodeship: 'mazowieckie',
        logo: 'schubert.png',
        path: 'jubiler-schubert-warszawa-glebocka-15',
    },
    {
        id: '42',
        order: 44,
        name: 'Jubiler Schubert',
        originalAddress: 'Górczewska 124, 01-460 Warszawa',
        address: {
            street: 'Górczewska 124',
            city: 'Warszawa',
            postalCode: '01-460',
        },
        originalPhone: '22 665 94 22 e-sklep@jubilerschubert.pl',
        phones: ['+48 226 659 422'],
        emails: ['e-sklep@jubilerschubert.pl'],
        www: ['https://jubilerschubert.pl'],
        voivodeship: 'mazowieckie',
        logo: 'schubert.png',
        path: 'jubiler-schubert-warszawa-gorczewska-124',
    },
    {
        id: '43',
        order: 14,
        name: 'Jubiler Schubert',
        originalAddress: 'CH Serenada, Aleja Generała Tadeusza Bora-Komorowskiego 41, 31-876 Kraków',
        address: {
            street: 'Aleja Generała Tadeusza Bora-Komorowskiego 41',
            city: 'Kraków',
            postalCode: '31-876',
            place: 'CH Serenada',
        },
        originalPhone: '503 985 967 e-sklep@jubilerschubert.pl',
        phones: ['+48 503 985 967'],
        emails: ['e-sklep@jubilerschubert.pl'],
        www: ['https://jubilerschubert.pl'],
        voivodeship: 'malopolskie',
        logo: 'schubert.png',
        path: 'jubiler-schubert-krakow',
    },
    {
        id: '44',
        order: 15,
        name: 'Jubiler Schubert',
        originalAddress: 'Pawia 5, 31-154 Kraków',
        address: {
            street: 'Pawia 5',
            city: 'Kraków',
            postalCode: '31-154',
        },
        originalPhone: '503985977 e-sklep@jubilerschubert.pl',
        phones: ['+48 503 985 977'],
        emails: ['e-sklep@jubilerschubert.pl'],
        www: ['https://jubilerschubert.pl'],
        voivodeship: 'malopolskie',
        logo: 'schubert.png',
        path: 'jubiler-schubert-krakow-pawia-5',
    },
    {
        id: '45',
        order: 94,
        name: 'Jubiler Schubert',
        originalAddress: 'Bukowska 156, 60-189 Poznań',
        address: {
            street: 'Bukowska 156',
            city: 'Poznań',
            postalCode: '60-189',
        },
        originalPhone: '503 986 761 e-sklep@jubilerschubert.pl',
        phones: ['+48 503 986 761'],
        emails: ['e-sklep@jubilerschubert.pl'],
        www: ['https://jubilerschubert.pl'],
        voivodeship: 'wielkopolskie',
        logo: 'schubert.png',
        path: 'jubiler-schubert-poznan',
    },
    {
        id: '46',
        order: 95,
        name: 'Jubiler Schubert',
        originalAddress: 'Galeria handlowa Posnania, Pleszewska 1, 61-136 Poznań',
        address: {
            street: 'Pleszewska 1',
            city: 'Poznań',
            postalCode: '61-136',
            place: 'Galeria handlowa Posnania',
        },
        originalPhone: '503 986 892 e-sklep@jubilerschubert.pl',
        phones: ['+48 503 986 892'],
        emails: ['e-sklep@jubilerschubert.pl'],
        www: ['https://jubilerschubert.pl'],
        voivodeship: 'wielkopolskie',
        logo: 'schubert.png',
        path: 'jubiler-schubert-poznan-pleszewska-1',
    },
    {
        id: '47',
        order: 96,
        name: 'Jubiler Schubert',
        originalAddress: 'Głogowska 432, 60-004 Poznań',
        address: {
            street: 'Głogowska 432',
            city: 'Poznań',
            postalCode: '60-004',
        },
        originalPhone: '503 985 486 e-sklep@jubilerschubert.pl',
        phones: ['+48 503 985 486'],
        emails: ['e-sklep@jubilerschubert.pl'],
        www: ['https://jubilerschubert.pl'],
        voivodeship: 'wielkopolskie',
        logo: 'schubert.png',
        path: 'jubiler-schubert-poznan-glogowska-432',
    },
    {
        id: '48',
        order: 10,
        name: 'Salon Jubilo',
        originalAddress: 'ul Konopnickiej 19 58-500 Jelenia Góra',
        address: {
            street: 'ul Konopnickiej 19',
            city: 'Jelenia Góra',
            postalCode: '58-500',
        },
        originalPhone: 'ekokarat@gmail.com sklep internetowy -517 728 206 sklep stacjonarny - 509 623 820',
        phones: ['+48 517 728 206', '+48 509 623 820'],
        emails: ['ekokarat@gmail.com'],
        www: ['https://www.ekokarat.pl'],
        voivodeship: 'dolnoslaskie',
        logo: 'jubilo.png',
        path: 'salon-jubilo-jelenia-gora',
    },
    {
        id: '5',
        order: 54,
        name: 'Salon Jubilerski SZAFIR',
        originalAddress: 'ul. Gocłowskiego 10, 07-410 Ostrołęka',
        address: {
            street: 'ul. Gocłowskiego 10',
            city: 'Ostrołęka',
            postalCode: '07-410',
        },
        originalPhone: '605-318-145 szafir.annawojcik@wp.pl',
        phones: ['+48 605 318 145'],
        emails: ['szafir.annawojcik@wp.pl'],
        www: [],
        socials: {
            facebook: 'https://www.facebook.com/SalonSzafir',
        },
        voivodeship: 'mazowieckie',
        logo: 'szafir.png',
        path: 'salon-jubilerski-szafir-ostroleka',
    },
    {
        id: '50',
        order: 105,
        name: 'Salon Jubilo',
        originalAddress: 'ul. 14 Lutego 16, 64-920 Piła',
        address: {
            street: 'ul. 14 Lutego 16',
            city: 'Piła',
            postalCode: '64-920',
        },
        originalPhone: '514 855 731 ekokarat@gmail.com',
        phones: ['+48 514 855 731'],
        emails: ['ekokarat@gmail.com'],
        www: ['https://www.ekokarat.pl'],
        voivodeship: 'wielkopolskie',
        logo: 'jubilo.png',
        path: 'salon-jubilo-pila',
    },
    {
        id: '51',
        order: 20,
        name: 'WENC FIRMA JUBILERSKA',
        originalAddress: '30-698 Kraków ul.Myślenicka 133 I piętro l',
        address: {
            street: 'ul. Myślenicka 133 I piętro',
            city: 'Kraków',
            postalCode: '30-698',
        },
        originalPhone: 'kon. 12 656-16-06; 508127382',
        phones: ['+48 508 127 382', '+48 126 561 606'],
        emails: [],
        www: ['https://www.wenc.pl'],
        voivodeship: 'malopolskie',
        logo: 'wenc.png',
        path: 'wenc-firma-jubilerska-krakow',
    },
    {
        id: '52',
        order: 21,
        name: 'WENC FIRMA JUBILERSKA',
        originalAddress: '32-410 Dobczyce Rynek 37',
        address: {
            street: 'Rynek 37',
            city: 'Dobczyce',
            postalCode: '32-410',
        },
        originalPhone: 'kon. 12 271-02-72 , 508127382',
        phones: ['+48 508 127 382', '+48 122 710 272'],
        emails: [],
        www: ['https://www.wenc.pl'],
        voivodeship: 'malopolskie',
        logo: 'wenc.png',
        path: 'wenc-firma-jubilerska-dobczyce',
    },
    {
        id: '53',
        order: 6,
        name: 'GESELLE Jubiler',
        originalAddress: 'ul. Kołłątaja 21 50-006 Wrocław',
        address: {
            street: 'ul. Kołłątaja 21',
            city: 'Wrocław',
            postalCode: '50-006',
        },
        originalPhone: '796 600 111 geselle.jubiler@gmail.com',
        phones: ['+48 796 600 111'],
        emails: ['geselle.jubiler@gmail.com'],
        www: ['https://geselle.pl'],
        voivodeship: 'dolnoslaskie',
        logo: 'geselle.png',
        path: 'geselle-jubiler',
    },
    {
        id: '54',
        order: 24,
        name: 'Robert Siudek Jubiler',
        originalAddress: 'UL.Wielopole 24 31-070 Kraków',
        address: {
            street: 'UL.Wielopole 24',
            city: 'Kraków',
            postalCode: '31-070',
        },
        originalPhone: '607781178 robert@siudek.com.pl',
        phones: ['+48 607 781 178'],
        emails: ['robert@siudek.com.pl'],
        www: ['https://www.siudek.com.pl'],
        voivodeship: 'malopolskie',
        logo: 'siudek-jewellery.png',
        path: 'robert-siudek-jubiler',
    },
    {
        id: '55',
        order: 39,
        name: 'Zakład Jubilerski Dominik Jelonkiewicz',
        originalAddress: 'Ul. 3 maja 12 32-100 Proszowice',
        address: {
            street: 'ul. 3 maja 12',
            city: 'Proszowice',
            postalCode: '32-100',
        },
        originalPhone: '123861623',
        phones: ['+48 123 861 623'],
        emails: [],
        www: [],
        voivodeship: 'malopolskie',
        logo: 'placeholder.png',
        path: 'zaklad-jubilerski-dominik-jelonkiewicz',
    },
    {
        id: '56',
        order: 23,
        name: 'Firma złotniczo jubilerska ALIANS',
        originalAddress: '30-504 Kraków ul.Kalwaryjska 32',
        address: {
            street: 'ul. Kalwaryjska 32',
            city: 'Kraków',
            postalCode: '30-504',
        },
        originalPhone: '48122963280 502047257',
        phones: ['+48 502 047 257', '+48 122 963 280'],
        emails: [],
        www: [],
        socials: {
            facebook: 'https://www.facebook.com/jubileralians',
        },
        voivodeship: 'malopolskie',
        logo: 'alians.png',
        path: 'firma-zlotniczo-jubilerska-alians',
        bgColor: '#400403',
    },
    {
        id: '57',
        order: 12,
        name: 'DUKAT Przetwórstwo i Obrót Metalami i Kamieniami Szlachetnymi Wiesław Nowak',
        originalAddress: '58-100 Świdnica Rynek 9/02',
        address: {
            street: 'Rynek 9/02',
            city: 'Świdnica',
            postalCode: '58-100',
        },
        originalPhone: '74 831 08 78 dukat-nowak@wp.pl',
        phones: ['+48 748 310 878'],
        emails: ['dukat-nowak@wp.pl'],
        www: [],
        voivodeship: 'dolnoslaskie',
        logo: 'dukat.png',
        path: 'dukat-przetworstwo-i-obrot-metalami-i-kamieniami-szlachetnymi-wieslaw-nowak',
    },
    {
        id: '58',
        order: 22,
        name: 'PROMA S.C. PIOTR MICHALIK, ADRIANA ŁAPUSZEK - MICHALIK',
        originalAddress: '31-504 Kraków ul. Kurkowa 5/8,',
        address: {
            street: 'ul. Kurkowa 5/8',
            city: 'Kraków',
            postalCode: '31-504',
        },
        originalPhone: '12 294 14 03 mail: biuro@srebroproma.pl',
        phones: ['+48 122 941 403'],
        emails: ['biuro@srebroproma.pl'],
        www: ['https://www.srebroproma.pl'],
        voivodeship: 'malopolskie',
        logo: 'proma.png',
        path: 'proma-sc-piotr-michalik-adriana-lapuszek-michalik-krakow',
    },
    {
        id: '59',
        order: 82,
        name: 'PROMA S.C. PIOTR MICHALIK, ADRIANA ŁAPUSZEK - MICHALIK',
        originalAddress: '41-500 Chorzów ul.Kilińskiego 5',
        address: {
            street: 'ul. Kilińskiego 5',
            city: 'Chorzów',
            postalCode: '41-500',
        },
        originalPhone: '32 771 05 34 mail: biuro@srebroproma.pl',
        phones: ['+48 327 710 534'],
        emails: ['biuro@srebroproma.pl'],
        www: ['https://www.srebroproma.pl'],
        voivodeship: 'slaskie',
        logo: 'proma.png',
        path: 'proma-sc-piotr-michalik-adriana-lapuszek-michalik-chorzow',
    },
    {
        id: '6',
        order: 55,
        name: 'Salon Jubilerski SZAFIR',
        originalAddress: 'ul. Rynek 16, 06-200 Maków Mazowiecki',
        address: {
            street: 'ul. Rynek 16',
            city: 'Maków Mazowiecki',
            postalCode: '06-200',
        },
        originalPhone: '790-780-728 szafir.annawojcik@wp.pl',
        phones: ['+48 790 780 728'],
        emails: ['szafir.annawojcik@wp.pl'],
        www: [],
        socials: {
            facebook: 'https://www.facebook.com/SalonSzafir',
        },
        voivodeship: 'mazowieckie',
        logo: 'szafir.png',
        path: 'salon-jubilerski-szafir-makow-mazowiecki',
    },
    {
        id: '60',
        order: 65,
        name: 'F.P.H.U. “SKORPION”',
        originalAddress: 'Galeria Jurajska Al. Wojska Polskiego 207 42-200 Częstochowa',
        address: {
            street: 'Al. Wojska Polskiego 207',
            city: 'Częstochowa',
            postalCode: '42-200',
            place: 'Galeria Jurajska',
        },
        originalPhone: '500 045 954 skorpion.jurajska@op.pl',
        phones: ['+48 500 045 954'],
        emails: ['skorpion.jurajska@op.pl'],
        www: ['https://jubilerskorpion.pl'],
        voivodeship: 'slaskie',
        logo: 'skorpion.png',
        path: 'fphu-skorpion-czestochowa',
    },
    {
        id: '61',
        order: 66,
        name: 'F.P.H.U. “SKORPION”',
        originalAddress: 'Galeria Agora Plac Tadeusza Kościuszki 41-902 Bytom',
        address: {
            street: 'Plac Tadeusza Kościuszki',
            city: 'Bytom',
            postalCode: '41-902',
            place: 'Galeria Agora',
        },
        originalPhone: '512 076 200 skorpion.agora@op.pl',
        phones: ['+48 512 076 200'],
        emails: ['skorpion.agora@op.pl'],
        www: ['https://jubilerskorpion.pl'],
        voivodeship: 'slaskie',
        logo: 'skorpion.png',
        path: 'fphu-skorpion-bytom',
    },
    {
        id: '62',
        order: 67,
        name: 'F.P.H.U. “SKORPION”',
        originalAddress: 'Galeria Silesia ul. Chorzowska 107 40-101 Katowice',
        address: {
            street: 'ul. Chorzowska 107',
            city: 'Katowice',
            postalCode: '40-101',
            place: 'Galeria Silesia',
        },
        originalPhone: '789 325 885 skorpion.katowice@op.pl',
        phones: ['+48 789 325 885'],
        emails: ['skorpion.katowice@op.pl'],
        www: ['https://jubilerskorpion.pl'],
        voivodeship: 'slaskie',
        logo: 'skorpion.png',
        path: 'fphu-skorpion-katowice',
    },
    {
        id: '63',
        order: 68,
        name: 'F.P.H.U. “SKORPION”',
        originalAddress: 'Biała Galeria ul. Mostowa 2 43-300 Bielsko Biała',
        address: {
            street: 'ul. Mostowa 2',
            city: 'Bielsko Biała',
            postalCode: '43-300',
            place: 'Biała Galeria',
        },
        originalPhone: '512 020 656 skorpion.sfera@op.pl',
        phones: ['+48 512 020 656'],
        emails: ['skorpion.sfera@op.pl'],
        www: ['https://jubilerskorpion.pl'],
        voivodeship: 'slaskie',
        logo: 'skorpion.png',
        path: 'fphu-skorpion-bielsko-biala',
    },
    {
        id: '64',
        order: 50,
        name: 'Golden Rabbit Dom Mody Klif',
        originalAddress: 'ul. Ostrobramska 75C 04-175 Warszawa',
        address: {
            street: 'ul. Ostrobramska 75C',
            city: 'Warszawa',
            postalCode: '04-175',
            place: 'G City Promenada',
        },
        originalPhone: '+48 667 097 767 ewelina.zajac@goldenrabbit.pl',
        phones: ['+48 667 097 767'],
        emails: ['ewelina.zajac@goldenrabbit.pl'],
        www: ['https://www.goldenrabbit.pl'],
        voivodeship: 'mazowieckie',
        logo: 'golden-rabbit.png',
        path: 'golden-rabbit-dom-mody-klif',
    },
    {
        id: '65',
        order: 56,
        name: 'Dan Biżuteria',
        originalAddress: 'ul. Senatorska 10, 08-400 Garwolin',
        address: {
            street: 'ul. Senatorska 10',
            city: 'Garwolin',
            postalCode: '08-400',
        },
        originalPhone: '795511363 dan_bizuteria@onet.eu',
        phones: ['+48 795 511 363'],
        emails: ['dan_bizuteria@onet.eu'],
        www: ['https://www.jubilernowicki.pl'],
        voivodeship: 'mazowieckie',
        logo: 'dan.png',
        path: 'dan-bizuteria',
    },
    {
        id: '66',
        order: 57,
        name: 'Galeria Złota Jubiler Nowicki',
        originalAddress: 'ul. Kościuszki 19, 08-400 Garwolin',
        address: {
            street: 'ul. Kościuszki 19',
            city: 'Garwolin',
            postalCode: '08-400',
        },
        originalPhone: '789560761 sklep@jubilernowicki.pl',
        phones: ['+48 789 560 761'],
        emails: ['sklep@jubilernowicki.pl'],
        www: ['https://www.jubilernowicki.pl'],
        voivodeship: 'mazowieckie',
        logo: 'galeria-zlota-nowicki.png',
        path: 'galeria-zlota-jubiler-nowicki',
    },
    {
        id: '67',
        order: 91,
        name: 'Firma Jubilerska Ilona Grzesik',
        originalAddress: 'Ul. Piłsudskiego 2 42-310 Żarki',
        address: {
            street: 'ul. Piłsudskiego 2',
            city: 'Żarki',
            postalCode: '42-310',
        },
        originalPhone: '606235143',
        phones: ['+48 606 235 143'],
        emails: [],
        www: [],
        socials: {
            facebook: 'https://www.facebook.com/JubilerZarki',
        },
        voivodeship: 'slaskie',
        logo: 'grzesik.png',
        path: 'firma-jubilerska-ilona-grzesik',
        bgColor: '#03061a',
    },
    {
        id: '68',
        order: 51,
        name: 'Kukla Gold',
        originalAddress: 'Plac Tysiąclecia 21, 08-110 Siedlce',
        address: {
            street: 'Plac Tysiąclecia 21',
            city: 'Siedlce',
            postalCode: '08-110',
        },
        originalPhone: '505 585 895 kontakt@kuklagold.pl',
        phones: ['+48 505 585 895'],
        emails: ['kontakt@kuklagold.pl'],
        www: ['https://www.kuklagold.pl'],
        voivodeship: 'mazowieckie',
        logo: 'kukla-gold.png',
        path: 'kukla-gold',
    },
    {
        id: '69',
        order: 93,
        name: 'Pracownia Złotnicza Uncja',
        originalAddress: '44-335 Jastrzębie-Zdrój ul, Wielkopolska 42b',
        address: {
            street: 'ul. Wielkopolska 42b',
            city: 'Jastrzębie-Zdrój',
            postalCode: '44-335',
        },
        originalPhone: '501070983 batata007@wp.pl',
        phones: ['+48 501 070 983'],
        emails: ['batata007@wp.pl'],
        www: [],
        socials: {
            facebook: 'https://www.facebook.com/pracowniazlotniczauncja',
        },
        voivodeship: 'slaskie',
        logo: 'uncja.png',
        path: 'pracownia-zlotnicza-uncja',
        bgColor: '#000',
    },
    {
        id: '7',
        order: 76,
        name: 'Jubiler TIK-TAK',
        originalAddress: 'Ul.Rynek 8/9, 47-400 Racibórz',
        address: {
            street: 'ul. Rynek 8/9',
            city: 'Racibórz',
            postalCode: '47-400',
        },
        originalPhone: '786 899 585 jubilertiktak@gmail.com',
        phones: ['+48 786 899 585'],
        emails: ['jubilertiktak@gmail.com'],
        www: [],
        voivodeship: 'slaskie',
        logo: 'tiktak.png',
        path: 'jubiler-tik-tak-raciborz',
        socials: {
            facebook: 'https://www.facebook.com/jubilerTikTak/',
        },
    },
    {
        id: '70',
        order: 52,
        name: 'Silverland s.c. Pióro&Chudawska',
        originalAddress: 'ul. Kilińskiego 14 08-110 Siedlce',
        address: {
            street: 'ul. Kilińskiego 14',
            city: 'Siedlce',
            postalCode: '08-110',
        },
        originalPhone: '(25) 63247-01 sklepsilverland@gmail.com 602-761-146',
        phones: ['+48 602 761 146', '+48 256 324 701'],
        emails: ['sklepsilverland@gmail.com'],
        www: [],
        voivodeship: 'mazowieckie',
        logo: 'silverland.png',
        path: 'silverland-sc-piorochudawska',
    },
    {
        id: '71',
        order: 70,
        name: 'SixSilver',
        originalAddress: 'Zwycięstwa 1. 44-121 Gliwice,',
        address: {
            street: 'Zwycięstwa 1.',
            city: 'Gliwice',
            postalCode: '44-121',
        },
        originalPhone: '730-602-665,',
        phones: ['+48 730 602 665'],
        emails: [],
        www: ['https://sixsilver.pl'],
        voivodeship: 'slaskie',
        logo: 'sixsilver.png',
        path: 'sixsilver-gliwice',
    },
    {
        id: '111',
        order: 58,
        name: 'Zakład Złotniczy Marek Koronka',
        originalAddress: 'ul. Kozienicka 36 26-670 Pionki',
        address: {
            street: 'ul. Kozienicka 36',
            city: 'Pionki',
            postalCode: '26-670',
        },
        originalPhone: ': 48 612 90 68 e-mail: zakladzlotniczy@wp.pl',
        phones: ['+48 486 129 068'],
        emails: ['zakladzlotniczy@wp.pl'],
        www: [],
        voivodeship: 'mazowieckie',
        logo: 'marek-koronka.png',
        path: 'zaklad-zlotniczy-marek-koronka',
    },
    {
        id: '72',
        order: 71,
        name: 'SixSilver',
        originalAddress: 'Arena Gliwice, Aleja Jana Nowaka Jeziorańskiego 1 , Gliwice',
        address: {
            street: 'Aleja Jana Nowaka Jeziorańskiego 1',
            city: 'Gliwice',
            postalCode: '44-100',
            place: 'Arena Gliwice',
        },
        originalPhone: '730-602-676, arena@sixsilver.pl,',
        phones: ['+48 730 602 676'],
        emails: ['arena@sixsilver.pl'],
        www: ['https://sixsilver.pl'],
        voivodeship: 'slaskie',
        logo: 'sixsilver.png',
        path: 'sixsilver-gliwice-aleja-jana-nowaka-jezioranskiego-1',
    },
    {
        id: '73',
        order: 72,
        name: 'SixSilver',
        originalAddress: 'Agora Bytom, Plac Kościuszki 1, Bytom',
        address: {
            street: 'Plac Kościuszki 1',
            city: 'Bytom',
            postalCode: '41-902',
            place: 'Agora Bytom',
        },
        originalPhone: '730-602-666, agora@sixsilver.pl',
        phones: ['+48 730 602 666'],
        emails: ['agora@sixsilver.pl'],
        www: ['https://sixsilver.pl'],
        voivodeship: 'slaskie',
        logo: 'sixsilver.png',
        path: 'sixsilver-bytom',
    },
    {
        id: '74',
        order: 83,
        name: 'Artis Kozłowscy S.C.',
        originalAddress: 'ul Jana III Sobieskiego 5 44-200 RYBNIK',
        address: {
            street: 'ul Jana III Sobieskiego 5',
            city: 'Rybnik',
            postalCode: '44-200',
        },
        originalPhone: '324238554 sklep@artis-jubiler.pl',
        phones: ['+48 324 238 554'],
        emails: ['sklep@artis-jubiler.pl'],
        www: ['http://artis-jubiler.pl'],
        voivodeship: 'slaskie',
        logo: 'artis.png',
        path: 'artis-kozlowscy-sc-rybnik',
    },
    {
        id: '75',
        order: 84,
        name: 'Artis Kozłowscy S.C.',
        originalAddress: 'Rynkowa 1 44-200 Rybnik',
        address: {
            street: 'Rynkowa 1',
            city: 'Rybnik',
            postalCode: '44-200',
        },
        originalPhone: '324223424 sklep@artis-jubiler.pl',
        phones: ['+48 324 223 424'],
        emails: ['sklep@artis-jubiler.pl'],
        www: ['http://artis-jubiler.pl'],
        voivodeship: 'slaskie',
        logo: 'artis.png',
        path: 'artis-kozlowscy-sc-rybnik-rynkowa-1',
    },
    {
        id: '76',
        order: 85,
        name: 'Pracownia i sklep jubilerski',
        originalAddress: 'ul. Hajducka 11 41-500 Chorzów',
        address: {
            street: 'ul. Hajducka 11',
            city: 'Chorzów',
            postalCode: '41-500',
        },
        originalPhone: '731 520 844 zlotnikkrzysteczko@gmail.com',
        phones: ['+48 731 520 844'],
        emails: ['zlotnikkrzysteczko@gmail.com'],
        www: [],
        voivodeship: 'slaskie',
        logo: 'jan-krzysteczko.png',
        path: 'pracownia-i-sklep-jubilerski-chorzow',
    },
    {
        id: '77',
        order: 86,
        name: 'Pracownia i sklep jubilerski',
        originalAddress: 'ul. Wolności 50 41-500 Chorzów',
        address: {
            street: 'ul. Wolności 50',
            city: 'Chorzów',
            postalCode: '41-500',
        },
        originalPhone: '692 513 693 zlotnikkrzysteczko@gmail.com',
        phones: ['+48 692 513 693'],
        emails: ['zlotnikkrzysteczko@gmail.com'],
        www: [],
        voivodeship: 'slaskie',
        logo: 'jan-krzysteczko.png',
        path: 'pracownia-i-sklep-jubilerski-chorzow-wolnosci-50',
    },
    {
        id: '78',
        order: 109,
        name: 'Salon Jubilerski WEMAR Anna Wojtkowiak-Tomalik',
        originalAddress: 'Dr. Kocha 54 64-200 Wolsztyn',
        address: {
            street: 'Dr. Kocha 54',
            city: 'Wolsztyn',
            postalCode: '64-200',
        },
        originalPhone: '668-667-556 Email: wemar@wolsztyn.com.pl',
        phones: ['+48 668 667 556'],
        emails: ['wemar@wolsztyn.com.pl'],
        www: [],
        socials: {
            facebook: 'https://www.facebook.com/wemarwolsztyn',
        },
        voivodeship: 'wielkopolskie',
        logo: 'wemar.png',
        path: 'salon-jubilerski-wemar-anna-wojtkowiak-tomalik',
    },
    {
        id: '79',
        order: 110,
        name: 'Jubiler Buszkiewicz s.c.',
        originalAddress: '62-035 Kórnik, Plac Niepodległości 33',
        address: {
            street: 'Plac Niepodległości 33',
            city: 'Kórnik',
            postalCode: '62-035',
        },
        originalPhone: '604 640 306 jubilerbuszkiewicz@gmail.com',
        phones: ['+48 604 640 306'],
        emails: ['jubilerbuszkiewicz@gmail.com'],
        www: [],
        socials: {
            facebook: 'https://www.facebook.com/jubiler.buszkiewicz',
        },
        voivodeship: 'wielkopolskie',
        logo: 'buszkiewicz.png',
        path: 'jubiler-buszkiewicz-sc',
        bgColor: '#f1e8c9',
    },
    {
        id: '8',
        order: 77,
        name: 'Jubiler TIK-TAK',
        originalAddress: 'Ul.Rynek 7, 47-400 Racibórz',
        address: {
            street: 'ul. Rynek 7',
            city: 'Racibórz',
            postalCode: '47-400',
        },
        originalPhone: '+48 324140346 jubilertiktak@gmail.com',
        phones: ['+48 324 140 346'],
        emails: ['jubilertiktak@gmail.com'],
        www: [],
        socials: {
            facebook: 'https://www.facebook.com/jubilerTikTak',
        },
        voivodeship: 'slaskie',
        logo: 'tiktak.png',
        path: 'jubiler-tik-tak-raciborz-rynek-7',
    },
    {
        id: '80',
        order: 37,
        name: 'Sklep”JUBILER” Dariusz Wójcik',
        originalAddress: 'Ul. Kościelna 17 33-370 Muszyna',
        address: {
            street: 'ul. Kościelna 17',
            city: 'Muszyna',
            postalCode: '33-370',
        },
        originalPhone: '508 050 838',
        phones: ['+48 508 050 838'],
        emails: [],
        www: [],
        voivodeship: 'malopolskie',
        logo: 'dariusz-wojcik.png',
        path: 'sklepjubiler-dariusz-wojcik',
    },
    {
        id: '81',
        order: 102,
        name: 'Jubiler Carre',
        originalAddress: 'CH Amber ul. Górnośląska 82 62-800 Kalisz',
        address: {
            street: 'ul. Górnośląska 82',
            city: 'Kalisz',
            postalCode: '62-800',
            place: 'CH Amber',
        },
        originalPhone: '+48697440300 carre@jubilercarre.pl',
        phones: ['+48 697 440 300'],
        emails: ['carre@jubilercarre.pl'],
        www: ['https://www.jubilercarre.pl'],
        voivodeship: 'wielkopolskie',
        logo: 'carre.png',
        path: 'jubiler-carre-kalisz',
    },
    {
        id: '82',
        order: 100,
        name: 'Jubiler Carre',
        originalAddress: 'CH Tęcza ul. 3 Maja 1 62-800 Kalisz',
        address: {
            street: 'ul. 3 Maja 1',
            city: 'Kalisz',
            postalCode: '62-800',
            place: 'CH Tęcza',
        },
        originalPhone: '+48697440300 carre@jubilercarre.pl',
        phones: ['+48 697 440 300'],
        emails: ['carre@jubilercarre.pl'],
        www: ['https://www.jubilercarre.pl'],
        voivodeship: 'wielkopolskie',
        logo: 'carre.png',
        path: 'jubiler-carre-kalisz-3-maja-1',
    },
    {
        id: '83',
        order: 101,
        name: 'Jubiler Carre',
        originalAddress: 'ul. Serbinowska 29 62-800 Kalisz',
        address: {
            street: 'ul. Serbinowska 29',
            city: 'Kalisz',
            postalCode: '62-800',
        },
        originalPhone: '+48697440300 carre@jubilercarre.pl',
        phones: ['+48 697 440 300'],
        emails: ['carre@jubilercarre.pl'],
        www: ['https://www.jubilercarre.pl'],
        voivodeship: 'wielkopolskie',
        logo: 'carre.png',
        path: 'jubiler-carre-kalisz-serbinowska-29',
    },
    {
        id: '9',
        order: 78,
        name: 'Jubiler TIK-TAK',
        originalAddress: 'Centrum Handlowe AuchanUl. Rybnicka 9747-400 Racibórz',
        address: {
            street: 'ul. Rybnicka 97',
            city: 'Racibórz',
            postalCode: '47-400',
            place: 'Centrum Handlowe Auchan',
        },
        originalPhone: '+48 607609603 jubilertiktak@gmail.com',
        phones: ['+48 607 609 603'],
        emails: ['jubilertiktak@gmail.com'],
        www: [],
        socials: {
            facebook: 'https://www.facebook.com/jubilerTikTak',
        },
        voivodeship: 'slaskie',
        logo: 'tiktak.png',
        path: 'jubiler-tik-tak-raciborz-rybnicka-97',
    },
    {
        id: '112',
        order: 111,
        name: 'Amoro Showroom Jubilerski',
        originalAddress: 'ul. Łódzka 4/6 (wejście D), 95-100 Zgierz',
        address: {
            street: 'ul. Łódzka 4/6',
            city: 'Zgierz',
            postalCode: '95-100',
        },
        originalPhone: '786-821-546 kontakt@amoro.pl',
        phones: ['+48 786 821 546'],
        emails: ['kontakt@amoro.pl'],
        www: ['https://www.amoro.pl'],
        voivodeship: 'lodzkie',
        logo: 'amoro.png',
        path: 'amoro-showroom-jubilerski',
    },
    {
        id: '113',
        order: 112,
        name: 'ArtGold Jubiler & Optyk',
        originalAddress: 'ul. Skłodowskiej-Curie 27, 85-088 Bydgoszcz',
        address: {
            street: 'ul. Skłodowskiej-Curie 27',
            city: 'Bydgoszcz',
            postalCode: '85-088',
        },
        originalPhone: '523452606',
        phones: ['+48 52 345 26 06'],
        emails: [],
        www: ['https://jubilerbydgoszcz.pl'],
        voivodeship: 'kujawsko-pomorskie',
        logo: 'artgold-logo.png',
        path: 'artgold-jubiler-optyk',
    },
    {
        id: '114',
        order: 113,
        name: 'TOPAZ Jubiler',
        originalAddress: 'ul. Kościuszki 75, 23-400 Biłgoraj',
        address: {
            street: 'ul. Kościuszki 75',
            city: 'Biłgoraj',
            postalCode: '23-400',
        },
        originalPhone: '+48 503 380 147 biuro@zegart.pl',
        phones: ['+48 503 380 147'],
        emails: ['biuro@zegart.pl'],
        www: ['https://www.zegart.pl'],
        voivodeship: 'lubelskie',
        logo: 'topaz-logo.png',
        path: 'topaz-jubiler-bilgoraj-kosciuszki',
    },
    {
        id: '115',
        order: 114,
        name: 'TOPAZ Jubiler',
        originalAddress: 'ul. Kopernika 27, 23-400 Biłgoraj',
        address: {
            street: 'ul. Kopernika 27',
            city: 'Biłgoraj',
            postalCode: '23-400',
        },
        originalPhone: '+48 503 380 147 biuro@zegart.pl',
        phones: ['+48 503 380 147'],
        emails: ['biuro@zegart.pl'],
        www: ['https://www.zegart.pl'],
        voivodeship: 'lubelskie',
        logo: 'topaz-logo.png',
        path: 'topaz-jubiler-bilgoraj-kopernika',
    },
    {
        id: '116',
        order: 115,
        name: 'Mago Silva Gerard Galewski',
        originalAddress: 'ul. Pocztowa 2, 22-300 Krasnystaw',
        address: {
            street: 'ul. Pocztowa 2',
            city: 'Krasnystaw',
            postalCode: '22-300',
        },
        originalPhone: '660016550 magosilva.poland@gmail.com',
        phones: ['+48 660 016 550'],
        emails: ['magosilva.poland@gmail.com'],
        www: [],
        socials: {
            facebook: 'https://www.facebook.com/magosilva.poland',
        },
        voivodeship: 'lubelskie',
        logo: 'mago-silva-logo.png',
        path: 'mago-silva-gerard-galewski',
    },
    {
        id: '117',
        order: 116,
        name: 'P.P.H.U Jantar Piotr Gotkowicz',
        originalAddress: 'ul. Juliusza 5 lokal 2, 98-220 Zduńska Wola',
        address: {
            street: 'ul. Juliusza 5 lokal 2',
            city: 'Zduńska Wola',
            postalCode: '98-220',
        },
        originalPhone: '513 195 815',
        phones: ['+48 513 195 815'],
        emails: [],
        www: [],
        voivodeship: 'lodzkie',
        logo: 'jantar-logo.png',
        path: 'pphu-jantar-piotr-gotkowicz',
    },
    {
        id: '118',
        order: 117,
        name: 'CS Jubiler',
        originalAddress: 'ul. Śląska 18, 98-300 Wieluń',
        address: {
            street: 'ul. Śląska 18',
            city: 'Wieluń',
            postalCode: '98-300',
        },
        originalPhone: '691-866-975 csjubiler@gmail.com',
        phones: ['+48 691 866 975'],
        emails: ['csjubiler@gmail.com'],
        www: [],
        socials: {
            instagram: 'https://www.instagram.com/csjubiler/',
        },
        voivodeship: 'lodzkie',
        logo: 'cs-jubiler-logo.png',
        path: 'cs-jubiler',
    },
    {
        id: '119',
        order: 118,
        name: 'BIŻUTERIA-WINIARCZYK',
        originalAddress: 'ul. Pileckiego 26, 97-400 Bełchatów',
        address: {
            street: 'ul. Pileckiego 26',
            city: 'Bełchatów',
            postalCode: '97-400',
        },
        originalPhone: '785001037 sklep@obraczka-slubna.pl',
        phones: ['+48 785 001 037'],
        emails: ['sklep@obraczka-slubna.pl'],
        www: [],
        voivodeship: 'lodzkie',
        logo: 'winiarczyk-logo.png',
        path: 'bizuteria-winiarczyk',
    },
    {
        id: '120',
        order: 119,
        name: 'Pracownia Jubilerska Mirosław Szczerkowski',
        originalAddress: 'ul. Zachodnia 55, 91-063 Łódź',
        address: {
            street: 'ul. Zachodnia 55',
            city: 'Łódź',
            postalCode: '91-063',
        },
        originalPhone: '42 630 47 34 mirekjubiler@interia.pl',
        phones: ['+48 42 630 47 34'],
        emails: ['mirekjubiler@interia.pl'],
        www: [],
        voivodeship: 'lodzkie',
        logo: 'szczerkowski-logo.png',
        path: 'pracownia-jubilerska-miroslaw-szczerkowski',
    },
    {
        id: '121',
        order: 120,
        name: 'Goldie - Salon Jubilerski Martyna Szczerkowska',
        originalAddress: 'ul. Zamkowa 24/4, 95-200 Pabianice',
        address: {
            street: 'ul. Zamkowa 24/4',
            city: 'Pabianice',
            postalCode: '95-200',
        },
        originalPhone: '664-450-609 jubiler.ms@wp.pl',
        phones: ['+48 664 450 609'],
        emails: ['jubiler.ms@wp.pl'],
        www: [],
        voivodeship: 'lodzkie',
        logo: 'goldie-logo.png',
        path: 'goldie-salon-jubilerski-martyna-szczerkowska',
    },
    {
        id: '122',
        order: 121,
        name: 'Jubiler EBIS',
        originalAddress: 'ul. Warszawska 13, 98-300 Wieluń, Centrum Handlowe Lilia',
        address: {
            street: 'ul. Warszawska 13',
            city: 'Wieluń',
            postalCode: '98-300',
            place: 'Centrum Handlowe Lilia',
        },
        originalPhone: '500619013 sklep@jubilerebis.pl',
        phones: ['+48 500 619 013'],
        emails: ['sklep@jubilerebis.pl'],
        www: ['https://jubilerebis.pl'],
        voivodeship: 'lodzkie',
        logo: 'ebis-logo.png',
        path: 'jubiler-ebis',
    },
    {
        id: '123',
        order: 122,
        name: 'COLLIA',
        originalAddress: 'ul. Kościuszki 23, 08-400 Garwolin',
        address: {
            street: 'ul. Kościuszki 23',
            city: 'Garwolin',
            postalCode: '08-400',
        },
        originalPhone: '608 012 475 collia23@wp.pl',
        phones: ['+48 608 012 475'],
        emails: ['collia23@wp.pl'],
        www: [],
        socials: {
            facebook: 'https://www.facebook.com/COLLIA-286030585073673',
        },
        voivodeship: 'mazowieckie',
        logo: 'collia-logo.png',
        path: 'collia',
    },
    {
        id: '124',
        order: 123,
        name: 'Goldmare Jubiler',
        originalAddress: 'ul. Wileńska 45, 05-200 Wołomin',
        address: {
            street: 'ul. Wileńska 45',
            city: 'Wołomin',
            postalCode: '05-200',
        },
        originalPhone: '534 334 334 kontakt@goldmar.pl',
        phones: ['+48 534 334 334'],
        emails: ['kontakt@goldmar.pl'],
        www: ['https://www.goldmare.pl'],
        voivodeship: 'mazowieckie',
        logo: 'goldmare-logo.png',
        path: 'goldmare-jubiler-wolomin-wilenska',
    },
    {
        id: '125',
        order: 124,
        name: 'Goldmare Jubiler',
        originalAddress: 'ul. Mieszka I nr 7, 05-200 Wołomin',
        address: {
            street: 'ul. Mieszka I 7',
            city: 'Wołomin',
            postalCode: '05-200',
        },
        originalPhone: '534 440 240 kontakt@goldmar.pl',
        phones: ['+48 534 440 240'],
        emails: ['kontakt@goldmar.pl'],
        www: ['https://www.goldmare.pl'],
        voivodeship: 'mazowieckie',
        logo: 'goldmare-logo.png',
        path: 'goldmare-jubiler-wolomin-mieszka',
    },
    {
        id: '126',
        order: 125,
        name: 'Firma Jubilerska KUNSZT Mirosław Wąsowicz',
        originalAddress: 'ul. Celna 10/1, 48-300 Nysa',
        address: {
            street: 'ul. Celna 10/1',
            city: 'Nysa',
            postalCode: '48-300',
        },
        originalPhone: '602229590 kunszt@op.pl',
        phones: ['+48 602 229 590'],
        emails: ['kunszt@op.pl'],
        www: [],
        socials: {
            facebook: 'https://www.facebook.com/people/Jubiler-Kunszt/100063713695903/',
        },
        voivodeship: 'opolskie',
        logo: 'placeholder.png',
        path: 'firma-jubilerska-kunszt',
    },
    {
        id: '127',
        order: 126,
        name: 'FUGART s.c.',
        originalAddress: 'al. Józefa Piłsudskiego 44, 35-001 Rzeszów',
        address: {
            street: 'al. Józefa Piłsudskiego 44',
            city: 'Rzeszów',
            postalCode: '35-001',
        },
        originalPhone: '512 618 571 sklep@fugart.pl',
        phones: ['+48 512 618 571'],
        emails: ['sklep@fugart.pl'],
        www: ['https://fugart.pl'],
        voivodeship: 'podkarpackie',
        logo: 'placeholder.png',
        path: 'fugart',
    },
    {
        id: '128',
        order: 127,
        name: 'Jubiler Turkus',
        originalAddress: 'ul. Okulickiego 25, 37-450 Stalowa Wola',
        address: {
            street: 'ul. Okulickiego 25',
            city: 'Stalowa Wola',
            postalCode: '37-450',
        },
        originalPhone: '+48 883 850 271 kontakt@jubilerturkus.pl',
        phones: ['+48 883 850 271'],
        emails: ['kontakt@jubilerturkus.pl'],
        www: ['https://jubilerturkus.pl'],
        voivodeship: 'podkarpackie',
        logo: 'turkus-logo.png',
        path: 'jubiler-turkus',
    },
    {
        id: '129',
        order: 128,
        name: 'Sklep Jubilerski Złoty Graal s.c. Elżbieta i Marek Cholewiccy',
        originalAddress: 'ul. Długa 12, 18-400 Łomża',
        address: {
            street: 'ul. Długa 12',
            city: 'Łomża',
            postalCode: '18-400',
        },
        originalPhone: '86 216 65 01, 606 992 049 cholmar@vp.pl',
        phones: ['+48 86 216 65 01', '+48 606 992 049'],
        emails: ['cholmar@vp.pl'],
        www: [],
        voivodeship: 'podlaskie',
        logo: 'placeholder.png',
        path: 'sklep-jubilerski-zloty-graal',
    },
    {
        id: '130',
        order: 129,
        name: 'Jubiler Pachocki',
        originalAddress: 'ul. Wyszyńskiego 2 lok. 82, 15-888 Białystok',
        address: {
            street: 'ul. Wyszyńskiego 2 lok. 82',
            city: 'Białystok',
            postalCode: '15-888',
        },
        originalPhone: '+48 537170161 jubilerpachocki@gmail.com',
        phones: ['+48 537 170 161'],
        emails: ['jubilerpachocki@gmail.com'],
        www: [],
        socials: {
            facebook: 'https://www.facebook.com/jubilerpachocki',
        },
        voivodeship: 'podlaskie',
        logo: 'pachocki-logo.png',
        path: 'jubiler-pachocki-bialystok',
    },
    {
        id: '131',
        order: 130,
        name: 'Jubiler Pachocki',
        originalAddress: 'ul. Piłsudskiego 2a lok.3, 16-100 Sokółka',
        address: {
            street: 'ul. Piłsudskiego 2a lok. 3',
            city: 'Sokółka',
            postalCode: '16-100',
        },
        originalPhone: '+48 730063370 jubilerpachocki@gmail.com',
        phones: ['+48 730 063 370'],
        emails: ['jubilerpachocki@gmail.com'],
        www: [],
        socials: { facebook: 'https://www.facebook.com/jubilerpachocki' },
        voivodeship: 'podlaskie',
        logo: 'pachocki-logo.png',
        path: 'jubiler-pachocki-sokolka-pilsudskiego',
    },
    {
        id: '132',
        order: 131,
        name: 'Jubiler Pachocki',
        originalAddress: 'ul. 1 Maja 3, 16-100 Sokółka',
        address: {
            street: 'ul. 1 Maja 3',
            city: 'Sokółka',
            postalCode: '16-100',
        },
        originalPhone: '+48 883203884 jubilerpachocki@gmail.com',
        phones: ['+48 883 203 884'],
        emails: ['jubilerpachocki@gmail.com'],
        www: [],
        socials: {
            facebook: 'https://www.facebook.com/jubilerpachocki',
        },
        voivodeship: 'podlaskie',
        logo: 'pachocki-logo.png',
        path: 'jubiler-pachocki-sokolka-1-maja',
    },
    {
        id: '133',
        order: 132,
        name: 'Firma Jubilerska Klejnot Zbigniew Błaszczyk',
        originalAddress: 'ul. Modrzejowska 29, 41-200 Sosnowiec',
        address: {
            street: 'ul. Modrzejowska 29',
            city: 'Sosnowiec',
            postalCode: '41-200',
        },
        originalPhone: '503-016-409',
        phones: ['+48 503 016 409'],
        emails: [],
        www: [],
        voivodeship: 'slaskie',
        logo: 'klejnot-logo.png',
        path: 'firma-jubilerska-klejnot-sosnowiec',
    },
    {
        id: '134',
        order: 133,
        name: 'Złotnik-Jubiler Cieszyn',
        originalAddress: 'ul. Głęboka 17, 43-400 Cieszyn',
        address: {
            street: 'ul. Głęboka 17',
            city: 'Cieszyn',
            postalCode: '43-400',
        },
        originalPhone: '33 8583664 zlotnikjubiler@gmail.com',
        phones: ['+48 33 858 36 64'],
        emails: ['zlotnikjubiler@gmail.com'],
        www: ['http://www.zlotnik-cieszyn.pl'],
        socials: {
            facebook: 'https://www.facebook.com/zlotnikjubilercieszyn',
        },
        voivodeship: 'slaskie',
        logo: 'zlotnik-jubiler.png',
        path: 'zlotnik-jubiler-cieszyn-gleboka-17',
    },
    {
        id: '135',
        order: 134,
        name: 'Złotnik-Jubiler Cieszyn',
        originalAddress: 'ul. Głęboka 41, 43-400 Cieszyn',
        address: {
            street: 'ul. Głęboka 41',
            city: 'Cieszyn',
            postalCode: '43-400',
        },
        originalPhone: '33 8580228 zlotnikjubiler@gmail.com',
        phones: ['+48 33 858 02 28'],
        emails: ['zlotnikjubiler@gmail.com'],
        www: ['http://www.zlotnik-cieszyn.pl'],
        socials: {
            facebook: 'https://www.facebook.com/zlotnikjubilercieszyn',
        },
        voivodeship: 'slaskie',
        logo: 'zlotnik-jubiler.png',
        path: 'zlotnik-jubiler-cieszyn-gleboka-41',
    },
    {
        id: '136',
        order: 135,
        name: 'Jubiler Klejnot',
        originalAddress: 'ul. Sienkiewicza 34, 25-507 Kielce',
        address: {
            street: 'ul. Sienkiewicza 34',
            city: 'Kielce',
            postalCode: '25-507',
        },
        originalPhone: '506 687 732 klejnot@klejnotkielce.pl',
        phones: ['+48 506 687 732'],
        emails: ['klejnot@klejnotkielce.pl'],
        www: ['https://klejnotkielce.pl'],
        voivodeship: 'swietokrzyskie',
        logo: 'klejnot-logo.png',
        path: 'jubiler-klejnot-kielce-sienkiewicza',
    },
    {
        id: '137',
        order: 136,
        name: 'Jubiler Klejnot',
        originalAddress: 'Plac Rynek 16, 25-303 Kielce',
        address: {
            street: 'Plac Rynek 16',
            city: 'Kielce',
            postalCode: '25-303',
        },
        originalPhone: '508 929 004 klejnot@klejnotkielce.pl',
        phones: ['+48 508 929 004'],
        emails: ['klejnot@klejnotkielce.pl'],
        www: ['https://klejnotkielce.pl'],
        voivodeship: 'swietokrzyskie',
        logo: 'klejnot-logo.png',
        path: 'jubiler-klejnot-kielce-rynek',
    },
    {
        id: '138',
        order: 137,
        name: 'Sklep - Zakład Jubilerski Jerzy Orłowski',
        originalAddress: 'ul. Dąbrowszczaków 35b, 10-542 Olsztyn',
        address: {
            street: 'ul. Dąbrowszczaków 35b',
            city: 'Olsztyn',
            postalCode: '10-542',
        },
        originalPhone: '895235888, 784 080 681',
        phones: ['+48 895 235 888', '+48 784 080 681'],
        emails: [],
        www: ['http://www.jubiler-orlowski.pl'],
        voivodeship: 'warminsko-mazurskie',
        logo: 'orlowski-logo.png',
        path: 'sklep-zaklad-jubilerski-jerzy-orlowski',
    },
    {
        id: '139',
        order: 138,
        name: 'Filipowicz',
        originalAddress: 'ul. Krzywoustego 17/2, 70-252 Szczecin',
        address: {
            street: 'ul. Krzywoustego 17/2',
            city: 'Szczecin',
            postalCode: '70-252',
        },
        originalPhone: '509 253 325',
        phones: ['+48 509 253 325'],
        emails: [],
        www: ['https://www.filipowicz.pl'],
        voivodeship: 'zachodniopomorskie',
        logo: 'filipowicz-logo.png',
        path: 'filipowicz',
    },
    {
        id: '140',
        order: 139,
        name: 'Margo Jubiler',
        originalAddress: 'ul. Piłsudskiego 89A, 73-110 Stargard',
        address: {
            street: 'ul. Piłsudskiego 89A',
            city: 'Stargard',
            postalCode: '73-110',
        },
        originalPhone: '517323112',
        phones: ['+48 517 323 112'],
        emails: [],
        www: ['https://margo.stargard.pl'],
        voivodeship: 'zachodniopomorskie',
        logo: 'margo-logo.png',
        path: 'margo-jubiler-stargard-pilsudskiego',
    },
    {
        id: '141',
        order: 140,
        name: 'Margo Jubiler',
        originalAddress: 'ul. Czarnieckiego 1/3, 73-110 Stargard, CH RONDO',
        address: {
            street: 'ul. Czarnieckiego 1/3',
            city: 'Stargard',
            postalCode: '73-110',
            place: 'CH RONDO',
        },
        originalPhone: '797292155',
        phones: ['+48 797 292 155'],
        emails: [],
        www: ['https://margo.stargard.pl'],
        voivodeship: 'zachodniopomorskie',
        logo: 'margo-logo.png',
        path: 'margo-jubiler-stargard-rondo',
    },
    {
        id: '142',
        order: 141,
        name: 'Kotkowiak Jubiler Police',
        originalAddress: 'ul. Rycerska 7A, 72-010 Police',
        address: {
            street: 'ul. Rycerska 7A',
            city: 'Police',
            postalCode: '72-010',
        },
        originalPhone: '502 955 718 jubiler.police@wp.pl',
        phones: ['+48 502 955 718'],
        emails: ['jubiler.police@wp.pl'],
        www: [],
        socials: {
            facebook: 'https://web.facebook.com/Jubiler.Police/',
        },
        voivodeship: 'zachodniopomorskie',
        logo: 'kotkowiak-logo.png',
        path: 'kotkowiak-jubiler-police',
    },
    {
        id: '143',
        order: 142,
        name: 'Sin Art Chwastek Dawid',
        originalAddress: 'ul. Piłsudskiego 31, 27-200 Starachowice',
        address: {
            street: 'ul. Piłsudskiego 31',
            city: 'Starachowice',
            postalCode: '27-200',
        },
        originalPhone: '889 273 273, 534 844 385 jubiler.sin@gmail.com',
        phones: ['+48 889 273 273', '+48 534 844 385'],
        emails: ['jubiler.sin@gmail.com'],
        www: [],
        socials: {
            facebook: 'https://www.facebook.com/p/Sin-Art-Chwastek-Dawid-100028020380229/',
        },
        voivodeship: 'swietokrzyskie',
        logo: 'sinart-logo.png',
        path: 'sin-art-chwastek-dawid',
    },
    {
        id: '144',
        order: 143,
        name: 'Zakład Złotniczo-Jubilerski Ewa Koguciuk',
        originalAddress: 'ul. Morska 9, 76-150 Darłowo',
        address: {
            street: 'ul. Morska 9',
            city: 'Darłowo',
            postalCode: '76-150',
        },
        originalPhone: '694015702',
        phones: ['+48 694 015 702'],
        emails: [],
        www: [],
        voivodeship: 'zachodniopomorskie',
        logo: 'koguciuk-logo.png',
        path: 'zaklad-zlotniczo-jubilerski-ewa-koguciuk',
    },
    {
        id: '145',
        order: 144,
        name: 'IZI Pracownia Złotnicza Alan Andrzejewski',
        originalAddress: 'Władysława Reymonta 28, 46-072 Opole',
        address: {
            street: 'ul. Władysława Reymonta 28',
            city: 'Opole',
            postalCode: '46-072',
        },
        originalPhone: '+48 889802903',
        phones: ['+48 889 802 903'],
        emails: [],
        www: [],
        socials: {
            facebook: 'https://www.facebook.com/izijubiler',
        },
        voivodeship: 'opolskie',
        logo: 'izi-logo.png',
        path: 'izi-pracownia-zlotnicza-alan-andrzejewski',
    },
    {
        id: '146',
        order: 145,
        name: 'Pracownia Złotnicza Załanowski Lesław',
        originalAddress: 'Rynek 9, 48-385 Otmuchów',
        address: {
            street: 'Rynek 9',
            city: 'Otmuchów',
            postalCode: '48-385',
        },
        originalPhone: '77 431 51 43, +48 600 377 888 leslaw73@gmail.com',
        phones: ['+48 77 431 51 43', '+48 600 377 888'],
        emails: ['leslaw73@gmail.com'],
        www: [],
        socials: {
            facebook: 'https://www.facebook.com/JubilerZalanowski/',
            instagram: 'https://www.instagram.com/jubiler_zalanowski',
        },
        voivodeship: 'opolskie',
        logo: 'zalanowski-logo.png',
        path: 'pracownia-zlotnicza-zalanowski-leslaw',
    },
    {
        id: '147',
        order: 146,
        name: 'Jubiler Froelke',
        originalAddress: 'ul. Rynek 2, 83-200 Starogard Gdański, Salon ślubny Bianka',
        address: {
            street: 'ul. Rynek 2',
            city: 'Starogard Gdański',
            postalCode: '83-200',
            place: 'Salon ślubny Bianka',
        },
        originalPhone: '503705801 biankaf@wp.pl',
        phones: ['+48 503 705 801'],
        emails: ['biankaf@wp.pl'],
        www: [],
        voivodeship: 'pomorskie',
        logo: 'froelke-logo.png',
        path: 'jubiler-froelke',
    },
    {
        id: '148',
        order: 147,
        name: 'Jubiler Ryszard Bliger',
        originalAddress: 'ul. Piłsudskiego 94, 50-017 Wrocław',
        address: {
            street: 'ul. Piłsudskiego 94',
            city: 'Wrocław',
            postalCode: '50-017',
        },
        originalPhone: '71 34 330 43 jubiler@rbliger.pl',
        phones: ['+48 71 343 30 43'],
        emails: ['jubiler@rbliger.pl'],
        www: ['https://www.rbliger.pl'],
        voivodeship: 'dolnoslaskie',
        logo: 'bliger-logo.png',
        path: 'jubiler-ryszard-bliger',
    },
    {
        id: '149',
        order: 148,
        name: 'Zakład złotniczy Piotr Skoczylas',
        originalAddress: 'ul. Kasztelańska 1, Wałbrzych',
        address: {
            street: 'ul. Kasztelańska 1',
            city: 'Wałbrzych',
            postalCode: '58-300',
        },
        originalPhone: '74 666 42 25 piotr.skoczylas00@gmail.com',
        phones: ['+48 74 666 42 25'],
        emails: ['piotr.skoczylas00@gmail.com'],
        www: [],
        voivodeship: 'dolnoslaskie',
        logo: 'placeholder.png',
        path: 'zaklad-zlotniczy-piotr-skoczylas',
    },
    {
        id: '150',
        order: 149,
        name: 'Salony Jubilerskie KORZELIK',
        originalAddress: 'ul. Łukowa 14, Świdnica',
        address: {
            street: 'ul. Łukowa 14',
            city: 'Świdnica',
            postalCode: '58-100',
        },
        originalPhone: '531735370 korzelik.firma@gmail.com',
        phones: ['+48 531 735 370'],
        emails: ['korzelik.firma@gmail.com'],
        www: [],
        socials: {
            facebook: 'https://www.facebook.com/sjkorzelik',
        },
        voivodeship: 'dolnoslaskie',
        logo: 'korzelik-logo.png',
        path: 'salony-jubilerskie-korzelik-lukowa',
    },
    {
        id: '151',
        order: 150,
        name: 'Salony Jubilerskie KORZELIK',
        originalAddress: 'ul. Rynek 42, Świdnica',
        address: {
            street: 'ul. Rynek 42',
            city: 'Świdnica',
            postalCode: '58-100',
        },
        originalPhone: '533 033 261 korzelik.firma@gmail.com',
        phones: ['+48 533 033 261'],
        emails: ['korzelik.firma@gmail.com'],
        www: [],
        socials: {
            facebook: 'https://www.facebook.com/sjkorzelik',
        },
        voivodeship: 'dolnoslaskie',
        logo: 'korzelik-logo.png',
        path: 'salony-jubilerskie-korzelik-rynek',
    },
    {
        id: '152',
        order: 151,
        name: 'Firma Jubilerska AURA Renata Korzelik',
        originalAddress: 'Rynek 47, 58-200 Dzierżoniów',
        address: {
            street: 'Rynek 47',
            city: 'Dzierżoniów',
            postalCode: '58-200',
        },
        originalPhone: '666 911 545 sylwia.kozak9@wp.pl',
        phones: ['+48 666 911 545'],
        emails: ['sylwia.kozak9@wp.pl'],
        www: [],
        socials: {
            facebook: 'https://www.facebook.com/firmajubilerskaaura/',
        },
        voivodeship: 'dolnoslaskie',
        logo: 'placeholder.png',
        path: 'firma-jubilerska-aura-renata-korzelik',
    },
    {
        id: '153',
        order: 152,
        name: 'Cardano - salony obrączek ślubnych',
        originalAddress: 'ul. Świętej Katarzyny 4, 87-100 Toruń',
        address: {
            street: 'ul. Świętej Katarzyny 4',
            city: 'Toruń',
            postalCode: '87-100',
        },
        originalPhone: '+48 535 560 730 torun@cardano.pl',
        phones: ['+48 535 560 730'],
        emails: ['torun@cardano.pl'],
        www: ['https://www.cardano.pl/obraczki-slubne'],
        voivodeship: 'kujawsko-pomorskie',
        logo: 'cardano-logo.png',
        path: 'cardano-torun',
    },
    {
        id: '154',
        order: 153,
        name: 'Cardano - salony obrączek ślubnych',
        originalAddress: 'ul. Warmińskiego 1, 85-054 Bydgoszcz',
        address: {
            street: 'ul. Warmińskiego 1',
            city: 'Bydgoszcz',
            postalCode: '85-054',
        },
        originalPhone: '+48 535 560 730 bydgoszcz@cardano.pl',
        phones: ['+48 535 560 730'],
        emails: ['bydgoszcz@cardano.pl'],
        www: ['https://www.cardano.pl/obraczki-slubne'],
        voivodeship: 'kujawsko-pomorskie',
        logo: 'cardano-logo.png',
        path: 'cardano-bydgoszcz',
    },
    {
        id: '155',
        order: 154,
        name: 'Jubiler Schubert',
        originalAddress: 'ul. Schuberta 102A, 80-172 Gdańsk, Morena',
        address: {
            street: 'ul. Schuberta 102A',
            city: 'Gdańsk',
            postalCode: '80-172',
            place: 'Morena',
        },
        originalPhone: '+48 503 985 454 sklep@jubilerschubert.pl',
        phones: ['+48 503 985 454'],
        emails: ['sklep@jubilerschubert.pl'],
        www: ['https://jubilerschubert.pl/'],
        voivodeship: 'pomorskie',
        logo: 'schubert.png',
        path: 'jubiler-schubert-gdansk-morena',
    },
    {
        id: '156',
        order: 155,
        name: 'Jubiler Schubert',
        originalAddress: 'ul. Szczęśliwa 3, 80-178 Gdańsk, Auchan',
        address: {
            street: 'ul. Szczęśliwa 3',
            city: 'Gdańsk',
            postalCode: '80-178',
            place: 'Auchan',
        },
        originalPhone: '+48 503 985 619 auchan@jubilerschubert.pl',
        phones: ['+48 503 985 619'],
        emails: ['auchan@jubilerschubert.pl'],
        www: ['https://jubilerschubert.pl/'],
        voivodeship: 'pomorskie',
        logo: 'schubert.png',
        path: 'jubiler-schubert-gdansk-auchan',
    },
    {
        id: '157',
        order: 156,
        name: 'Jubiler Schubert',
        originalAddress: 'ul. Jana Karskiego 5, 91-071 Łódź, Manufaktura',
        address: {
            street: 'ul. Jana Karskiego 5',
            city: 'Łódź',
            postalCode: '91-071',
            place: 'Manufaktura',
        },
        originalPhone: '+48 503 985 212',
        phones: ['+48 503 985 212'],
        emails: [],
        www: ['https://jubilerschubert.pl/'],
        voivodeship: 'lodzkie',
        logo: 'schubert.png',
        path: 'jubiler-schubert-lodz-manufaktura',
    },
    {
        id: '158',
        order: 157,
        name: 'Jubiler Schubert',
        originalAddress: 'ul. Wrocławska 154, 45-837 Opole, Karolinka',
        address: {
            street: 'ul. Wrocławska 154',
            city: 'Opole',
            postalCode: '45-837',
            place: 'Karolinka',
        },
        originalPhone: '+48 503 985 815',
        phones: ['+48 503 985 815'],
        emails: [],
        www: ['https://jubilerschubert.pl/'],
        voivodeship: 'opolskie',
        logo: 'schubert.png',
        path: 'jubiler-schubert-opole-karolinka',
    },
    {
        id: '159',
        order: 158,
        name: 'Pracownia Złotnicza Krystyna Piekarczyk',
        originalAddress: 'ul. Rynek 6, 48-200 Prudnik',
        address: {
            street: 'ul. Rynek 6',
            city: 'Prudnik',
            postalCode: '48-200',
        },
        originalPhone: '77 4361601',
        phones: ['+48 77 436 16 01'],
        emails: [],
        www: [],
        voivodeship: 'opolskie',
        logo: 'piekarczyk-logo.png',
        path: 'pracownia-zlotnicza-krystyna-piekarczyk',
    },
    {
        id: '160',
        order: 159,
        name: 'Clue-Point Joanna Piekarczyk',
        originalAddress: 'ul. Wiejska 4, 48-200 Prudnik, Kaufland',
        address: {
            street: 'ul. Wiejska 4',
            city: 'Prudnik',
            postalCode: '48-200',
            place: 'Kaufland',
        },
        originalPhone: '774362796',
        phones: ['+48 77 436 27 96'],
        emails: [],
        www: [],
        voivodeship: 'opolskie',
        logo: 'placeholder.png',
        path: 'clue-point-joanna-piekarczyk',
    },
    {
        id: '161',
        order: 160,
        name: 'JUBILER GOLD-SILVER',
        originalAddress: 'Pl. Wolności 16, 21-500 Biała Podlaska',
        address: {
            street: 'Pl. Wolności 16',
            city: 'Biała Podlaska',
            postalCode: '21-500',
        },
        originalPhone: '833444191',
        phones: ['+48 83 344 41 91'],
        emails: [],
        www: [],
        voivodeship: 'lubelskie',
        logo: 'placeholder.png',
        path: 'jubiler-gold-silver',
    },
    {
        id: '162',
        order: 161,
        name: 'Jubiler Skorpion',
        originalAddress: 'ul. Bolesława Chrobrego 1, Radom, Galeria Słoneczna',
        address: {
            street: 'ul. Bolesława Chrobrego 1',
            city: 'Radom',
            postalCode: '26-600',
            place: 'Galeria Słoneczna',
        },
        originalPhone: '509 837 050 radomjubilerskorpion@gmail.com',
        phones: ['+48 509 837 050'],
        emails: ['radomjubilerskorpion@gmail.com'],
        www: ['https://jubilerskorpion.pl/'],
        voivodeship: 'mazowieckie',
        logo: 'skorpion.png',
        path: 'jubiler-skorpion-radom',
    },
    {
        id: '163',
        order: 162,
        name: 'Jubiler Skorpion',
        originalAddress: 'ul. Sienkiewicza 40, Kielce, Salon Firmowy',
        address: {
            street: 'ul. Sienkiewicza 40',
            city: 'Kielce',
            postalCode: '25-507',
            place: 'Salon Firmowy',
        },
        originalPhone: '506 193 073 jubiler.skorpion@op.pl',
        phones: ['+48 506 193 073'],
        emails: ['jubiler.skorpion@op.pl'],
        www: ['https://jubilerskorpion.pl/'],
        voivodeship: 'swietokrzyskie',
        logo: 'skorpion.png',
        path: 'jubiler-skorpion-kielce-sienkiewicza',
    },
    {
        id: '164',
        order: 163,
        name: 'Jubiler Skorpion',
        originalAddress: 'ul. Świętokrzyska 20, 25-406 Kielce, Galeria Echo',
        address: {
            street: 'ul. Świętokrzyska 20',
            city: 'Kielce',
            postalCode: '25-406',
            place: 'Galeria Echo',
        },
        originalPhone: '500 047 097 jubilerskorpionecho@op.pl',
        phones: ['+48 500 047 097'],
        emails: ['jubilerskorpionecho@op.pl'],
        www: ['https://jubilerskorpion.pl/'],
        voivodeship: 'swietokrzyskie',
        logo: 'skorpion.png',
        path: 'jubiler-skorpion-kielce-echo',
    },
    {
        id: '165',
        order: 164,
        name: 'Jubiler Skorpion',
        originalAddress: 'ul. Warszawska 26, Kielce, Galeria Korona',
        address: {
            street: 'ul. Warszawska 26',
            city: 'Kielce',
            postalCode: '25-312',
            place: 'Galeria Korona',
        },
        originalPhone: '504 445 009 skorpion.korona@op.pl',
        phones: ['+48 504 445 009'],
        emails: ['skorpion.korona@op.pl'],
        www: ['https://jubilerskorpion.pl/'],
        voivodeship: 'swietokrzyskie',
        logo: 'skorpion.png',
        path: 'jubiler-skorpion-kielce-korona',
    },
    {
        id: '166',
        order: 165,
        name: 'Jubiler Skorpion',
        originalAddress: 'ul. Mickiewicza 62, 28-200 Staszów, Galeria Staszowska',
        address: {
            street: 'ul. Mickiewicza 62',
            city: 'Staszów',
            postalCode: '28-200',
            place: 'Galeria Staszowska',
        },
        originalPhone: '506 193 355 ',
        phones: ['+48 506 193 355 '],
        emails: [],
        www: ['https://jubilerskorpion.pl/'],
        voivodeship: 'swietokrzyskie',
        logo: 'skorpion.png',
        path: 'jubiler-skorpion-staszow',
    },
    {
        id: '167',
        order: 166,
        name: 'Jubiler Celina Krówczyńska sp.j',
        originalAddress: 'ul. Długa 35, 49-300 Brzeg',
        address: {
            street: 'ul. Długa 35',
            city: 'Brzeg',
            postalCode: '49-300',
        },
        originalPhone: '501505171 jubilercelina@gmail.com',
        phones: ['+48 501 505 171'],
        emails: ['jubilercelina@gmail.com'],
        www: [],
        socials: {
            facebook: 'https://www.facebook.com/jubilercelina',
        },
        voivodeship: 'opolskie',
        logo: 'placeholder.png',
        path: 'jubiler-celina-krowczynska',
    },
    {
        id: '168',
        order: 167,
        name: 'Asimex Plus',
        originalAddress: 'ul. Przechodnia 6/11, 23-204 Kraśnik',
        address: {
            street: 'ul. Przechodnia 6/11',
            city: 'Kraśnik',
            postalCode: '23-204',
        },
        originalPhone: '+48 605130655 biuro@asimexplus.com',
        phones: ['+48 605 130 655'],
        emails: ['biuro@asimexplus.com'],
        www: ['https://www.asimexplus.com'],
        voivodeship: 'lubelskie',
        logo: 'asimex-logo.png',
        path: 'asimex-plus',
    },
    {
        id: '169',
        order: 168,
        name: 'Jubiler Ryszard Mikłuszka Since 1980',
        originalAddress: 'ul. Kołłątaja 1, 47-100 Strzelce Opolskie',
        address: {
            street: 'ul. Kołłątaja 1',
            city: 'Strzelce Opolskie',
            postalCode: '47-100',
        },
        originalPhone: '+48 600 439 888 jubiler1@op.pl',
        phones: ['+48 600 439 888'],
        emails: ['jubiler1@op.pl'],
        www: [],
        socials: {
            instagram: 'https://www.instagram.com/jubiler_ryszard_mikluszka',
        },
        voivodeship: 'opolskie',
        logo: 'mikluszka-logo.png',
        path: 'jubiler-ryszard-mikluszka',
    },
    {
        id: '170',
        order: 169,
        name: 'DUKAT Jubiler E.K.',
        originalAddress: 'ul. Piaskowa 7/A16, 24-100 Puławy',
        address: {
            street: 'ul. Piaskowa 7/A16',
            city: 'Puławy',
            postalCode: '24-100',
        },
        originalPhone: '660-287-396 erwin.kostka@gmail.com',
        phones: ['+48 660 287 396'],
        emails: ['erwin.kostka@gmail.com'],
        www: [],
        socials: {
            facebook: 'https://www.facebook.com/profile.php?id=100028020113668',
        },
        voivodeship: 'lubelskie',
        logo: 'dukat-logo.png',
        path: 'dukat-jubiler-ek-pulawy',
    },
    {
        id: '171',
        order: 170,
        name: 'Sklep Jubilerski Radosław Jędrzejczyk',
        originalAddress: 'Pl. Legionów 6a, 98-300 Wieluń',
        address: {
            street: 'Pl. Legionów 6a',
            city: 'Wieluń',
            postalCode: '98-300',
        },
        originalPhone: '43 843 00 96 jubiler.wielun@gmail.com',
        phones: ['+48 43 843 00 96'],
        emails: ['jubiler.wielun@gmail.com'],
        www: [],
        voivodeship: 'lodzkie',
        logo: 'placeholder.png',
        path: 'sklep-jubilerski-radoslaw-jedrzejczyk-legionow',
    },
    {
        id: '172',
        order: 171,
        name: 'Sklep Jubilerski Radosław Jędrzejczyk',
        originalAddress: 'ul. Śląska 4, 98-300 Wieluń',
        address: {
            street: 'ul. Śląska 4',
            city: 'Wieluń',
            postalCode: '98-300',
        },
        originalPhone: '43 843 00 96 jubiler.wielun@gmail.com',
        phones: ['+48 43 843 00 96'],
        emails: ['jubiler.wielun@gmail.com'],
        www: [],
        voivodeship: 'lodzkie',
        logo: 'placeholder.png',
        path: 'sklep-jubilerski-radoslaw-jedrzejczyk-slaska',
    },
    {
        id: '173',
        order: 172,
        name: 'Jubiler Jaracz',
        originalAddress: 'ul. Piłsudskiego 58, 38-400 Krosno',
        address: {
            street: 'ul. Piłsudskiego 58',
            city: 'Krosno',
            postalCode: '38-400',
        },
        originalPhone: '134 327 954',
        phones: ['+48 134 327 954'],
        emails: [],
        www: ['https://jubiler.jaracz.pl/'],
        voivodeship: 'podkarpackie',
        logo: 'jaracz-logo.png',
        path: 'jubiler-jaracz-krosno',
    },
    {
        id: '174',
        order: 173,
        name: 'Jubiler Jaracz',
        originalAddress: 'ul. Podwisłocze 21, 35-309 Rzeszów',
        address: {
            street: 'ul. Podwisłocze 21',
            city: 'Rzeszów',
            postalCode: '35-309',
        },
        originalPhone: '666 626 888',
        phones: ['+48 666 626 888'],
        emails: [],
        www: ['https://jubiler.jaracz.pl/'],
        voivodeship: 'podkarpackie',
        logo: 'jaracz-logo.png',
        path: 'jubiler-jaracz-rzeszow-podwislocze',
    },
    {
        id: '175',
        order: 174,
        name: 'Jubiler Jaracz',
        originalAddress: 'ul. Kopisto 11, 35-315 Rzeszów',
        address: {
            street: 'ul. Kopisto 11',
            city: 'Rzeszów',
            postalCode: '35-315',
        },
        originalPhone: '508 500 585',
        phones: ['+48 508 500 585'],
        emails: [],
        www: ['https://jubiler.jaracz.pl/'],
        voivodeship: 'podkarpackie',
        logo: 'jaracz-logo.png',
        path: 'jubiler-jaracz-rzeszow-kopisto',
    },
    {
        id: '176',
        order: 175,
        name: 'Jubiler Jaracz',
        originalAddress: 'ul. Lwowska 26, 33-300 Nowy Sącz',
        address: {
            street: 'ul. Lwowska 26',
            city: 'Nowy Sącz',
            postalCode: '33-300',
        },
        originalPhone: '797 797 585',
        phones: ['+48 797 797 585'],
        emails: [],
        www: ['https://jubiler.jaracz.pl/'],
        voivodeship: 'malopolskie',
        logo: 'jaracz-logo.png',
        path: 'jubiler-jaracz-nowy-sacz',
    },
    {
        id: '177',
        order: 176,
        name: 'Jubiler Jaracz',
        originalAddress: 'ul. K. Wielkiego 3, 34-400 Nowy Targ',
        address: {
            street: 'ul. K. Wielkiego 3',
            city: 'Nowy Targ',
            postalCode: '34-400',
        },
        originalPhone: '501 333 585',
        phones: ['+48 501 333 585'],
        emails: [],
        www: ['https://jubiler.jaracz.pl/'],
        voivodeship: 'malopolskie',
        logo: 'jaracz-logo.png',
        path: 'jubiler-jaracz-nowy-targ',
    },
    {
        id: '178',
        order: 177,
        name: 'Silver Home Pracownia Złotnicza Piotr Jonik',
        originalAddress: 'ul. Józefa Marka 6, 34-600 Limanowa',
        address: {
            street: 'ul. Józefa Marka 6',
            city: 'Limanowa',
            postalCode: '34-600',
        },
        originalPhone: '',
        phones: [],
        emails: [],
        www: [],
        voivodeship: 'malopolskie',
        logo: 'silver-home-logo.png',
        path: 'silver-home-pracownia-zlotnicza-limanowa',
    },
    {
        id: '179',
        order: 178,
        name: 'Silver Home Pracownia Złotnicza Piotr Jonik',
        originalAddress: 'ul. Starowiejska 4c, 34-730 Mszana Dolna',
        address: {
            street: 'ul. Starowiejska 4c',
            city: 'Mszana Dolna',
            postalCode: '34-730',
        },
        originalPhone: '501079427',
        phones: ['+48 501 079 427'],
        emails: [],
        www: [],
        voivodeship: 'malopolskie',
        logo: 'silver-home-logo.png',
        path: 'silver-home-pracownia-zlotnicza-mszana-dolna',
    },
    {
        id: '180',
        order: 179,
        name: 'Sklep i zakład złotniczo zegarmistrzowski Aleksandro',
        originalAddress: 'ul. Raciborska 425, 44-280 Rydułtowy',
        address: {
            street: 'ul. Raciborska 425',
            city: 'Rydułtowy',
            postalCode: '44-280',
        },
        originalPhone: '502 535 014',
        phones: ['+48 502 535 014'],
        emails: [],
        www: [],
        voivodeship: 'slaskie',
        logo: 'aleksandro-logo.png',
        path: 'sklep-zaklad-zlotniczo-zegarmistrzowski-aleksandro',
    },
    {
        id: '181',
        order: 180,
        name: 'Salon Jubilerski Domańscy',
        originalAddress: 'ul. Pabianicka 245, 93-457 Łódź',
        address: {
            street: 'ul. Pabianicka 245',
            city: 'Łódź',
            postalCode: '93-457',
            place: 'CH Port Łódź',
        },
        originalPhone: '532 016 999',
        phones: ['+48 532 016 999'],
        emails: [],
        www: ['https://www.jubiler-domanscy.pl'],
        voivodeship: 'lodzkie',
        logo: 'domanscy-logo.png',
        path: 'jubiler-domanscy-port-lodz',
    },
    {
        id: '182',
        order: 181,
        name: 'Dariusz Korzeb Zakład Jubilerski',
        originalAddress: 'ul. Danusi 1, 80-434 Gdańsk',
        address: {
            street: 'ul. Danusi 1',
            city: 'Gdańsk',
            postalCode: '80-434',
        },
        originalPhone: '58 520 13 73 kontakt@korzeb.com.pl',
        phones: ['+48 58 520 13 73'],
        emails: ['kontakt@korzeb.com.pl'],
        www: [],
        voivodeship: 'pomorskie',
        logo: 'korzeb-logo.png',
        path: 'dariusz-korzeb-gdansk',
    },
    {
        id: '183',
        order: 182,
        name: 'Kamea',
        originalAddress: 'Rynek 48, 64-500 Szamotuły',
        address: {
            street: 'Rynek 48',
            city: 'Szamotuły',
            postalCode: '64-500',
        },
        originalPhone: '604 299 262',
        phones: ['+48 604 299 262'],
        emails: [],
        www: ['https://www.jubilerszamotuly.pl'],
        voivodeship: 'wielkopolskie',
        logo: 'kamea-logo.png',
        path: 'kamea-szamotuly',
    },
    {
        id: '184',
        order: 183,
        name: 'Złotnik - Jubiler Rafał Kołodziej',
        originalAddress: 'ul. Śródmiejska 13, 68-200 Żary',
        address: {
            street: 'ul. Śródmiejska 13',
            city: 'Żary',
            postalCode: '68-200',
        },
        originalPhone: '660 576 222 zlotnikkolodziej@onet.pl',
        phones: ['+48 660 576 222'],
        emails: ['zlotnikkolodziej@onet.pl'],
        www: ['https://www.zlotnikkolodziej.pl'],
        voivodeship: 'lubuskie',
        logo: 'kolodziej-logo.png',
        path: 'zlotnik-jubiler-rafal-kolodziej-zary',
    },
    {
        id: '185',
        order: 184,
        name: 'Goldmar Marcin Tomczak',
        originalAddress: 'Ul. Rynek 20, 63-700 Krotoszyn',
        address: {
            street: 'ul. Rynek 20',
            city: 'Krotoszyn',
            postalCode: '63-700',
        },
        originalPhone: '500 660 111 70@wp.pl',
        phones: ['+48 500 660 111'],
        emails: ['70@wp.pl'],
        www: [],
        voivodeship: 'wielkopolskie',
        logo: 'goldmar-logo.png',
        path: 'goldmar-marcin-tomczak-krotoszyn',
    },
    {
        id: '186',
        order: 185,
        name: 'Stoiska Jubilerskie Kress',
        originalAddress: 'ul. Plac Wolności 11, 87-800 Włocławek',
        address: {
            street: 'ul. Plac Wolności 11',
            city: 'Włocławek',
            postalCode: '87-800',
            place: 'D.T. Jacob',
        },
        originalPhone: '882-180-795 kress-jacob@tlen.pl',
        phones: ['+48 882 180 795'],
        emails: ['kress-jacob@tlen.pl'],
        www: [],
        socials: {
            facebook: 'https://www.facebook.com/p/Jubiler-Kress-100057822152995/',
            instagram: 'https://www.instagram.com/jubiler.kress',
        },
        voivodeship: 'kujawsko-pomorskie',
        logo: 'placeholder.png',
        path: 'jubiler-kress-wloclawek-jacob',
    },
    {
        id: '187',
        order: 186,
        name: 'SALON JUBILERSKI NOCULA',
        originalAddress: 'Al. Jana Pawła II 13A, 99-100 Łęczyca',
        address: {
            street: 'Al. Jana Pawła II 13A',
            city: 'Łęczyca',
            postalCode: '99-100',
        },
        originalPhone: '728480350 biuro@nocula.pl',
        phones: ['+48 728 480 350'],
        emails: ['biuro@nocula.pl'],
        www: ['https://www.nocula.pl'],
        voivodeship: 'lodzkie',
        logo: 'nocula-logo.png',
        path: 'salon-jubilerski-nocula-leczyca',
    },
    {
        id: '188',
        order: 187,
        name: 'Jubiler Sky',
        originalAddress: 'ul. Przeładunkowa 2, 68-200 Żary',
        address: {
            street: 'ul. Przeładunkowa 2',
            city: 'Żary',
            postalCode: '68-200',
        },
        originalPhone: '513896272 wilmansky2@gmail.com',
        phones: ['+48 513 896 272'],
        emails: ['wilmansky2@gmail.com'],
        www: ['https://www.facebook.com/profile.php?id=100063805072078'],
        voivodeship: 'lubuskie',
        logo: 'sky-logo.png',
        path: 'jubiler-sky-zary',
    },
    {
        id: '189',
        order: 188,
        name: 'Goldi Krzysztof Krajewski',
        originalAddress: 'ul. Gen. J. Hallera 3-5/9, 87-300 Brodnica',
        address: {
            street: 'ul. Gen. J. Hallera 3-5/9',
            city: 'Brodnica',
            postalCode: '87-300',
        },
        originalPhone: '564 942 666, 696 240 740',
        phones: ['+48 564 942 666', '+48 696 240 740'],
        emails: [],
        www: [],
        voivodeship: 'kujawsko-pomorskie',
        logo: 'placeholder.png',
        path: 'goldi-krzysztof-krajewski-brodnica',
    },
    {
        id: '190',
        order: 189,
        name: 'ONYX',
        originalAddress: 'ul. Rynek 14, 49-306 Brzeg',
        address: {
            street: 'ul. Rynek 14',
            city: 'Brzeg',
            postalCode: '49-306',
        },
        originalPhone: '+48 795 381 434 onyx@jubilerbrzeg.pl',
        phones: ['+48 795 381 434'],
        emails: ['onyx@jubilerbrzeg.pl'],
        www: ['https://www.jubilerbrzeg.pl'],
        voivodeship: 'opolskie',
        logo: 'onyx-logo.png',
        path: 'jubiler-onyx-brzeg-rynek',
    },
    {
        id: '191',
        order: 190,
        name: 'Jubiler Zegarmistrz Paweł Smykała',
        originalAddress: 'ul. Rybacka 1, 47-300 Krapkowice',
        address: {
            street: 'ul. Rybacka 1',
            city: 'Krapkowice',
            postalCode: '47-300',
        },
        originalPhone: '510 300 903, 774 460 369',
        phones: ['+48 510 300 903', '+48 774 460 369'],
        emails: [],
        www: ['https://www.ezegary.pl'],
        voivodeship: 'opolskie',
        logo: 'smykala-logo.png',
        path: 'jubiler-zegarmistrz-pawel-smykala',
    },
    {
        id: '192',
        order: 191,
        name: 'Pracownia Złotnicza RUBIN',
        originalAddress: 'Artura Grottgera 15, 65-061 Zielona Góra',
        address: {
            street: 'Artura Grottgera 15',
            city: 'Zielona Góra',
            postalCode: '65-061',
        },
        originalPhone: '68 324 51 51, 791 38 30 38',
        phones: ['+48 68 324 51 51', '+48 791 38 30 38'],
        emails: [],
        www: [],
        socials: {
            facebook: 'https://www.facebook.com/pzrubin',
            instagram: 'https://www.instagram.com/pzrubin',
        },
        voivodeship: 'lubuskie',
        logo: 'rubin-logo.png',
        path: 'pracownia-zlotnicza-rubin-zielona-gora',
    },
    {
        id: '193',
        order: 192,
        name: 'Salon Jubilerski Domańscy',
        originalAddress: 'al. Jana Pawła II 30, 93-570 Łódź',
        address: {
            street: 'al. Jana Pawła II 30',
            city: 'Łódź',
            postalCode: '93-570',
            place: 'CH Pasaż Łódzki',
        },
        originalPhone: '512 707 208',
        phones: ['+48 512 707 208'],
        emails: [],
        www: ['https://www.jubiler-domanscy.pl'],
        voivodeship: 'lodzkie',
        logo: 'domanscy-logo.png',
        path: 'jubiler-domanscy-pasaz-lodzki',
    },
    {
        id: '194',
        order: 193,
        name: 'Salon Jubilerski Domańscy',
        originalAddress: 'Plac Reymonta 3/4, 93-003 Łódź',
        address: {
            street: 'Plac Reymonta 3/4',
            city: 'Łódź',
            postalCode: '93-003',
        },
        originalPhone: '604 85 71 16',
        phones: ['+48 604 857 116'],
        emails: [],
        www: ['https://www.jubiler-domanscy.pl'],
        voivodeship: 'lodzkie',
        logo: 'domanscy-logo.png',
        path: 'jubiler-domanscy-plac-reymonta',
    },
    {
        id: '195',
        order: 194,
        name: 'Salon Jubilerski Domańscy',
        originalAddress: 'al. Piłsudskiego 94, 92-202 Łódź',
        address: {
            street: 'al. Piłsudskiego 94',
            city: 'Łódź',
            postalCode: '92-202',
            place: 'CH Tulipan',
        },
        originalPhone: '512 707 309',
        phones: ['+48 512 707 309'],
        emails: [],
        www: ['https://www.jubiler-domanscy.pl'],
        voivodeship: 'lodzkie',
        logo: 'domanscy-logo.png',
        path: 'jubiler-domanscy-tulipan-lodz',
    },
    {
        id: '196',
        order: 195,
        name: 'Stoiska Jubilerskie Kress',
        originalAddress: 'ul. Broniewskiego 5, 87-800 Włocławek',
        address: {
            street: 'ul. Broniewskiego 5',
            city: 'Włocławek',
            postalCode: '87-800',
            place: 'Tertio Ponte',
        },
        originalPhone: '882-182-972 kress-wislanin@tlen.pl',
        phones: ['+48 882 182 972'],
        emails: ['kress-wislanin@tlen.pl'],
        www: [],
        socials: {
            facebook: 'https://www.facebook.com/p/Jubiler-Kress-100057822152995/',
            instagram: 'https://www.instagram.com/jubiler.kress',
        },
        voivodeship: 'kujawsko-pomorskie',
        logo: 'placeholder.png',
        path: 'jubiler-kress-tertio-ponte-wloclawek',
    },
    {
        id: '197',
        order: 196,
        name: 'Stoiska Jubilerskie Kress',
        originalAddress: 'ul. Cmentarna 10, 87-800 Włocławek',
        address: {
            street: 'ul. Cmentarna 10',
            city: 'Włocławek',
            postalCode: '87-800',
            place: 'Auchan',
        },
        originalPhone: '882-184-579 kress-real@tlen.pl',
        phones: ['+48 882 184 579'],
        emails: ['kress-real@tlen.pl'],
        www: [],
        socials: {
            facebook: 'https://www.facebook.com/p/Jubiler-Kress-100057822152995/',
            instagram: 'https://www.instagram.com/jubiler.kress',
        },
        voivodeship: 'kujawsko-pomorskie',
        logo: 'placeholder.png',
        path: 'jubiler-kress-auchan-wloclawek',
    },
    {
        id: '198',
        order: 197,
        name: 'Stoiska Jubilerskie Kress',
        originalAddress: 'ul. Zielony Rynek 21, 87-800 Włocławek',
        address: {
            street: 'ul. Zielony Rynek 21',
            city: 'Włocławek',
            postalCode: '87-800',
            place: 'SDH Hala',
        },
        originalPhone: '882-184-348 kress-hala@tlen.pl',
        phones: ['+48 882 184 348'],
        emails: ['kress-hala@tlen.pl'],
        www: [],
        socials: {
            facebook: 'https://www.facebook.com/p/Jubiler-Kress-100057822152995/',
            instagram: 'https://www.instagram.com/jubiler.kress',
        },
        voivodeship: 'kujawsko-pomorskie',
        logo: 'placeholder.png',
        path: 'jubiler-kress-hala-wloclawek',
    },
    {
        id: '199',
        order: 198,
        name: 'Jubiler Sky',
        originalAddress: 'ul. Przyjaciół Żołnierza 7, 68-100 Żagań',
        address: {
            street: 'ul. Przyjaciół Żołnierza 7',
            city: 'Żagań',
            postalCode: '68-100',
        },
        originalPhone: '513896272 wilmansky2@gmail.com',
        phones: ['+48 513 896 272'],
        emails: ['wilmansky2@gmail.com'],
        www: ['https://www.facebook.com/profile.php?id=100063805072078'],
        voivodeship: 'lubuskie',
        logo: 'sky-logo.png',
        path: 'jubiler-sky-zagan',
    },
    {
        id: '200',
        order: 199,
        name: 'Jubiler Sky',
        originalAddress: 'ul. Armii Krajowej 14B, 74-400 Dębno',
        address: {
            street: 'ul. Armii Krajowej 14B',
            city: 'Dębno',
            postalCode: '74-400',
        },
        originalPhone: '513896272 wilmansky2@gmail.com',
        phones: ['+48 513 896 272'],
        emails: ['wilmansky2@gmail.com'],
        www: ['https://www.facebook.com/profile.php?id=100063805072078'],
        voivodeship: 'zachodniopomorskie',
        logo: 'sky-logo.png',
        path: 'jubiler-sky-debno',
    },
    {
        id: '201',
        order: 200,
        name: 'Jubiler Sky',
        originalAddress: 'ul. Sikorskiego 12, 66-470 Kostrzyn nad Odrą',
        address: {
            street: 'ul. Sikorskiego 12',
            city: 'Kostrzyn nad Odrą',
            postalCode: '66-470',
        },
        originalPhone: '513896272 wilmansky2@gmail.com',
        phones: ['+48 513 896 272'],
        emails: ['wilmansky2@gmail.com'],
        www: ['https://www.facebook.com/profile.php?id=100063805072078'],
        voivodeship: 'lubuskie',
        logo: 'sky-logo.png',
        path: 'jubiler-sky-kostrzyn-nad-odra',
    },
    {
        id: '202',
        order: 201,
        name: 'Sklep Jubilerski Bartosz Okrój',
        originalAddress: 'ul. Żwirki 42, 83-110 Tczew',
        address: {
            street: 'ul. Żwirki 42',
            city: 'Tczew',
            postalCode: '83-110',
            place: 'Hala 2, boks 28',
        },
        originalPhone: '606-438-220',
        phones: ['+48 606 438 220'],
        emails: [],
        www: [],
        voivodeship: 'pomorskie',
        logo: 'placeholder.png',
        path: 'sklep-jubilerski-bartosz-okroj-tczew',
    },
    {
        id: '203',
        order: 202,
        name: 'Jubiler Koral',
        originalAddress: 'ul. Okrzei 65d, 87-800 Włocławek',
        address: {
            street: 'ul. Okrzei 65d',
            city: 'Włocławek',
            postalCode: '87-800',
        },
        originalPhone: '500 400 301, 887 777 888',
        phones: ['+48 500 400 301', '+48 887 777 888'],
        emails: [],
        www: [],
        voivodeship: 'kujawsko-pomorskie',
        logo: 'placeholder.png',
        path: 'jubiler-koral-wloclawek',
    },
    {
        id: '204',
        order: 203,
        name: 'Pracownia Złotnicza Tadeusz Król',
        originalAddress: 'ul. Pionierów 16/1B, 11-300 Biskupiec',
        address: {
            street: 'ul. Pionierów 16/1B',
            city: 'Biskupiec',
            postalCode: '11-300',
        },
        originalPhone: '897 153 220',
        phones: ['+48 897 153 220'],
        emails: [],
        www: [],
        voivodeship: 'warminsko-mazurskie',
        logo: 'tadeusz-krol-logo.png',
        path: 'pracownia-zlotnicza-tadeusz-krol-biskupiec',
    },
    {
        id: '205',
        order: 204,
        name: 'ONYX',
        originalAddress: 'ul. Długa 23, 49-306 Brzeg',
        address: {
            street: 'ul. Długa 23',
            city: 'Brzeg',
            postalCode: '49-306',
        },
        originalPhone: '77 416 82 05 onyx@jubilerbrzeg.pl',
        phones: ['+48 77 416 82 05'],
        emails: ['onyx@jubilerbrzeg.pl'],
        www: ['https://www.jubilerbrzeg.pl'],
        voivodeship: 'opolskie',
        logo: 'onyx-logo.png',
        path: 'onyx-brzeg-dluga',
    },
    {
        id: '206',
        order: 205,
        name: 'Jubiler Głódkowski',
        originalAddress: 'ul. Katowicka 30B, 41-600 Świętochłowice',
        address: {
            street: 'ul. Katowicka 30B',
            city: 'Świętochłowice',
            postalCode: '41-600',
        },
        originalPhone: '508400535 322453646 swietochlowice@jubiler-glodkowski.pl',
        phones: ['+48 508 400 535', '+48 322 453 646'],
        emails: ['swietochlowice@jubiler-glodkowski.pl'],
        www: ['https://jubiler-glodkowski.pl'],
        voivodeship: 'slaskie',
        logo: 'glodkowski-logo.png',
        path: 'jubiler-glodkowski-swietochlowice',
    },
    {
        id: '207',
        order: 206,
        name: 'Złotnik Arkuszyński',
        originalAddress: 'pl. Bohaterów 4b, 77-300 Człuchów',
        address: {
            street: 'pl. Bohaterów 4b',
            city: 'Człuchów',
            postalCode: '77-300',
        },
        originalPhone: '59 83 44 281, kontakt@arkuszynski.pl',
        phones: ['+48 59 834 42 81'],
        emails: ['kontakt@arkuszynski.pl'],
        www: ['https://arkuszynski.pl/'],
        voivodeship: 'pomorskie',
        logo: 'arkuszynski-logo.png',
        path: 'zlotnik-arkuszynski-czluchow',
    },
    {
        id: '208',
        order: 207,
        name: 'GOLDING G.J. Pawłowska',
        originalAddress: 'ul. Sokola 4, SDH Bartek, 26-110 Skarżysko-Kamienna',
        address: {
            street: 'ul. Sokola 4',
            city: 'Skarżysko-Kamienna',
            postalCode: '26-110',
            place: 'SDH Bartek',
        },
        originalPhone: '',
        phones: [],
        emails: [],
        www: [],
        voivodeship: 'swietokrzyskie',
        logo: 'placeholder.png',
        path: 'golding-gj-pawlowska-skarzysko-kamienna',
    },
    {
        id: '209',
        order: 208,
        name: 'Salon firmowy Stelmach',
        originalAddress: 'ul. Rynek 26-27, 45-018 Opole',
        address: {
            street: 'ul. Rynek 26-27',
            city: 'Opole',
            postalCode: '45-018',
        },
        originalPhone: '77 441 44 44',
        phones: ['+48 77 441 44 44'],
        emails: ['rbu@stelmach.pl'],
        www: ['https://www.stelmach.pl/'],
        voivodeship: 'opolskie',
        logo: 'stelmach-logo.png',
        path: 'salon-firmowy-stelmach-opole',
    },
    {
        id: '210',
        order: 209,
        name: 'Pracownia Złotnicza Barbara Świetlik-Madej Sp. j.',
        originalAddress: 'ul. Grunwaldzka 40, 35-068 Rzeszów',
        address: {
            street: 'ul. Grunwaldzka 40',
            city: 'Rzeszów',
            postalCode: '35-068',
        },
        originalPhone: '17 8525518, +48 798367316',
        phones: ['+48 17 852 55 18', '+48 798 367 316'],
        emails: [],
        www: ['https://www.bm.rzeszow.pl'],
        voivodeship: 'podkarpackie',
        logo: 'bm.png',
        socials: {
            facebook: 'https://www.facebook.com/pracowniazlotniczabm/',
        },
        path: 'pracownia-zlotnicza-barbara-swietlik-madej-rzeszow-grunwaldzka',
    },
    {
        id: '211',
        order: 210,
        name: 'Pracownia Złotnicza Barbara Świetlik-Madej Sp. j.',
        originalAddress: 'ul. Jagiellońska 5, 35-025 Rzeszów',
        address: {
            street: 'ul. Jagiellońska 5',
            city: 'Rzeszów',
            postalCode: '35-025',
        },
        originalPhone: '17 852 9864, +48 798353540',
        phones: ['+48 17 852 98 64', '+48 798 353 540'],
        emails: [],
        www: ['https://www.bm.rzeszow.pl'],
        voivodeship: 'podkarpackie',
        logo: 'bm.png',
        socials: {
            facebook: 'https://www.facebook.com/pracowniazlotniczabm/',
        },
        path: 'pracownia-zlotnicza-barbara-swietlik-madej-rzeszow-jagiellonska',
    },
];
